import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../../layouts';
import axios from 'axios';
import configBase from '../../../../../configBase';
import InputMask from 'react-input-mask';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';
import {DropzoneDialog} from 'material-ui-dropzone';
import ReactToPrint from 'react-to-print';

import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LinearProgress from '@material-ui/core/LinearProgress';
import Switch from '@material-ui/core/Switch';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'



class Formulario extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      proposalNumber: '',
      imprimir: true,
      stepper: 0,// Posição inicial (0) do formulário
      showButtonBack: false,// Botão voltar
      showButtonFinished: false,// Botão concluir
      showButtonNext: true,// Botão avançar
      showButtonPrint: false,// Botão imprimir
      errorRequest: false,
      msgErrorRequest: "",
      value_plan : "",
      value_total :"",
      objectPlan: {},
      namePlanFull: "",
      unitary_value:"",
      unitary_value2:"",
      implantationRate: '0,00',
      valueIndividualPlan: '',
      lastValue: '',
      value_holder: '',
      value_dependent: '',
      fieldStep1: {
        reteveAdesao: {value: false, required: true, error: '', model: 'financialManager', type: ''},
        dateSignatureContractFm: {value: '', required: true, error: '', model: 'financialManager', type: ''},
        firstNameFm: {value: '', required: true, error: '', model: 'financialManager', type: 'text'},
        cpfFm: {value: '', required: true, error: '', loading: false, model: 'financialManager', type: ''},
        emailFm: {value: '', required: true, error: '', loading: false, model: 'financialManager', type: 'email'},
        homePhoneFm: {value: '', required: false, error: '', model: 'financialManager', type: 'fone'},
        cellPhoneFm: {value: '', required: true, error: '', model: 'financialManager', type: 'cel'},
        cellPhone2Fm: {value: '', required: false, error: '', model: 'financialManager', type: 'cel'},
        rgFm: {value: '', required: true, error: '', model: 'financialManager', type: 'number'},
        rgEmitterFm: {value: '', required: true, error: '', model: 'financialManager', type: 'text'},
        dateOfBirthFm: {value: null, required: true, error: '', model: 'financialManager', type: 'date'},
        motherNameFm: {value: '', required: true, error: '', model: 'financialManager', type: 'text'},
        maritalStatusFm: {value: 'null', required: true, error: '', model: 'financialManager', type: 'text'},
        genderFm: {value: 'null', required: true, error: '', model: 'financialManager', type: 'number'},
        susNumberFm: {value: '', required: false, error: '', model: 'financialManager', type: 'number'},
        matriculaFm: {value: '', required: false, error: '', model: 'financialManager', type: ''},
        admissionDateFm: {value: null, required: false, error: '', model: 'financialManager', type: 'date'},
        cepFm: {value: '', required: true, error: '', model: 'financialManager', type: ''},
        addressTypeFm: {value: 'null', required: true, error: '', loading: false, model: 'financialManager', type: 'number'},
        addressFm: {value: '', required: true, error: '', loading: false, model: 'financialManager', type: ''},
        addressNumberFm: {value: 1, required: true, error: '', model: 'financialManager', type: 'number'},
        stateFm: {value: 'null', required: true, error: '', loading: false, model: 'financialManager', type: 'number'},
        addressComplementFm: {value: '', required: false, error: '', model: 'financialManager', type: ''},
        cityFm: {value: 'null', required: true, error: '', loading: false, model: 'financialManager', type: 'number'},
        districtFm: {value: 'null', required: true, error: '', loading: false, model: 'financialManager', type: 'number'},

        firstNameHol: {value: '', required: true, error: '', model: 'holder', type: 'text'},
        susNumberHol: {value: '', required: false, error: '', model: 'holder', type: 'number'},
        motherNameHol: {value: '', required: true, error: '', model: 'holder', type: 'text'},
        cpfHol: {value: '', required: false, error: '', model: 'holder', type: ''},
        dateOfBirthHol: {value: null, required: true, error: '', model: 'holder', type: 'date'},
        maritalStatusHol: {value: 'null', required: true, error: '', model: 'holder', type: 'text'},
        genderHol: {value: 'null', required: true, error: '', model: 'holder', type: 'number'},
      },
      depIndex: 0,
      dependent: [
        {
          firstName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
          susNumber: {value: '', required: false, error: '', model: 'dependent', type: 'number'},
          motherName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
          cpf: {value: '', required: true, error: '', model: 'dependent', type: ''},
          dateOfBirth: {value: null, required: true, error: '', model: 'dependent', type: 'date'},
          maritalStatus: {value: 'null', required: true, error: '', model: 'dependent', type: 'text'},
          gender: {value: 'null', required: true, error: '', model: 'dependent', type: 'number'},
          parentage: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
          isHolder: {value: false, required: true, error: '', model: 'dependent', type: 'text'},
          plansId: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
          valuePlan: {value: 'null', required: false, error: '', model: 'dependent', type: ''},
        }
      ],
      dependentsList: [],
      stateList: [],
      cityList: [],
      addressTypeList: [],
      districtList: [],
      currentTimeServer: null,
      showFormHolder: false,
      showScriptTable: false,
      editDependent: {staus: false, index: 0},
      modalNoDependents: false,
      fullScreenModal: false,
      imagesDocsUrl: {
        cpf: {url: '', required: true, error: ''},
        rg: {url: '', required: true, error: ''},
        rg2: {url: '', required: true, error: ''},
        address: {url: '', required: true, error: ''},
        cardCredit: {url: '', required: false, error: ''},
        physicalContract: {url: '', required: false, error: ''},
        others: {url: '', required: true, error: ''},
      },
      dropzoneDialog: false,
      typeFile: '',
      finishedModal: false,
      finishedLoading: false,
      finishedLoadingMsg: 'BUSCANDO DADOS DO VENDEDOR...',
      finishedModalMinWidth: 300,
      finishedLoadingCompleted: 10,
      salesmanId: '',
      proposalSuccess: false,
      showPage: null,
      showMatricula: false,
      showAdmissionDateFm: false,
      checkedAtivaTermoAditivo: false,
      disabledNextButton: false,
      colorNextButton: configBase.corPrincipal,
      plansList: [],
      plansListFull: [],
      differentPlans: false,
      primeiroAcessoPasso1: true,
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      theadTh:{
        height: 40,
      },
    }

  }

  async componentDidMount() {
    await this.getDataInfoPlans();// Pega características do plano
    await this.getDataInfo();// Pega características do salesman broker
    await this.getStates();// Pega a lista de estados
    await this.getCurrentTimeServer();// Pega a data atual do servidor
    await this.fullScreenModalFn();

    let planos_plandep = localStorage.getItem("planos_plandep");

    // Caso tenha abrangenciaId e publico para pegar a lista de planos e exibir para dependentes
    if (planos_plandep !== null && planos_plandep !== 'null') {
      planos_plandep = planos_plandep.split('|');

      if (planos_plandep.length === 3)
        await this.getPlansList(planos_plandep[0], planos_plandep[1], planos_plandep[2]);
      else
        await this.getPlansList(planos_plandep[0], planos_plandep[1], null);
    }
  }

  async fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  async getPlansList(abrangenciaId, publico, typePayment) {
    let url = '';

    if (typePayment)
      url = 'Plans?filter={"where":{"and":[{"abrangenciaId":"' + abrangenciaId + '"},{"publico":"' + publico + '"},{"typePayment":"' + typePayment + '"}]}}&access_token='+localStorage.getItem('planos_t');
    else
      url = 'Plans?filter={"where":{"and":[{"abrangenciaId":"' + abrangenciaId + '"},{"publico":"' + publico + '"}]}}&access_token='+localStorage.getItem('planos_t');

    axios.get(configBase.api + url)
    .then((result) => {
      let state = this.state;
      state.plansList = [];
      state.plansListFull = result.data;

      for (let i = 0; i < result.data.length; i++) {
        state.plansList.push({
          value: result.data[i].id,
          label: result.data[i].name + ' - ' + result.data[i].qualificacao + ' - ' + result.data[i].area_atuacao + ' - ' +
            result.data[i].registro + ' - R$ ' + result.data[i].value + ' - ' + result.data[i].cobertura
        });
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.showPage = false;
      this.setError('Problema encontrado ao buscar lista de plano');
    }.bind(this));
  }

  // Pega características do plano
  async getDataInfoPlans() {
    let planChosenId = localStorage.getItem("planos_plan");

    // Pega o plano pelo ID do S4E
    if (planChosenId === null || planChosenId === 'null') {
      this.getPlansCompanyCode();
    }
    // Pega o plano pelo ID no banco
    else {
      axios.get(configBase.api + 'Plans/'+localStorage.getItem("planos_plan")+'?access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        let state = this.state;
        state.value_plan = result.data.value;
        state.lastValue = result.data.value;
        state.objectPlan = result.data;
        state.namePlanFull = result.data.name + ' - ' +
                             result.data.registro + ' - R$ ' + result.data.value + ' - ' + result.data.cobertura;
  
        if (result.data.familyTable.value2) {
          state.unitary_value = result.data.familyTable.value2;
          state.unitary_value2 = result.data.familyTable.value3;
        }
        else {
          state.unitary_value = result.data.value;
          state.unitary_value2 = result.data.value;
        }
  
        state.valueIndividualPlan = result.data.value;
        state.implantationRate = result.data.taxaImplantacao;
        state.value_total = ' '+((parseFloat(result.data.value.replace(',', '.'))+
        parseFloat(result.data.taxaImplantacao.replace(',', '.')))).toFixed(2).toString().replace('.', ',');
  
        // verifica se é servidor público
        if (state.objectPlan.publico === 'Servidor') {
          state.showMatricula = true;
          state.fieldStep1.matriculaFm.required = true;
        }
  
        // Obrigatoriedade dos anexos
        if (result.data.uploadDocRequired !== undefined && result.data.uploadDocRequired === false) {
          state.imagesDocsUrl.cpf.required = false;
          state.imagesDocsUrl.rg.required = false;
          state.imagesDocsUrl.rg2.required = false;
          state.imagesDocsUrl.address.required = false;
          state.imagesDocsUrl.others.required = false;
          state.imagesDocsUrl.physicalContract = false;
          state.imagesDocsUrl.cardCredit = false;
        }
  
        // Exibe conteúdo da página
        state.showPage = true;
  
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.showPage = false;
        this.setError('Problema encontrado ao buscar dados do plano');
      }.bind(this));
    }
    
  }

  getPlansCompanyCode() {
    let planChosen = localStorage.getItem("planos_plan2");

    // Caso encontre o plano
    if (planChosen !== null && planChosen !== 'null') {
      planChosen = planChosen.split('|');

      // Estrutura correta
      if (planChosen.length === 2) {
        let dataPost = {
          IdEmpresa: planChosen[0]
        };

        // Pega a empresa
        axios.post(configBase.api + 'APIS4s/Empresas?access_token='+localStorage.getItem('planos_t'), dataPost)
        .then((result) => {
          if (result.data !== null) {
            if (result.data.length > 0) {
              if (result.data[0].NomeSituacao !== 'CANCELADO') {
                // Pega os planos
                axios.post(configBase.api + 'APIS4s/Planos?access_token='+localStorage.getItem('planos_t'), dataPost)
                .then((result2) => {
                  if (result2.data !== null) {
                    if (result2.data.length > 0) {
                      let planFound = null;
        
                      for (let i = 0; i < result2.data.length; i++) {
                        if (parseInt(planChosen[1]) === result2.data[i].Id) {
                          planFound = result2.data[i];
                          break;
                        }
                      }
        
                      // Caso encontre o plano
                      if (planFound !== null) {
                        let state = this.state;
                        state.showPage = true;
                        state.value_plan = planFound.ValorTitular.toString().replace('.', ',');
                        state.namePlanFull = planFound.Nome + ' - R$ ' + Number.parseFloat(planFound.ValorTitular).toFixed(2).replace('.', ',');
                        state.implantationRate = '0,00';
                        state.value_total = planFound.ValorTitular.toFixed(2).replace('.', ',');
                        state.value_holder = planFound.ValorTitular.toFixed(2).replace('.', ',');
                        state.value_dependent = planFound.ValorDependente.toFixed(2).replace('.', ',');
                        // Para os anexos
                        state.imagesDocsUrl.cpf.required = false;
                        state.imagesDocsUrl.rg.required = false;
                        state.imagesDocsUrl.rg2.required = false;
                        state.imagesDocsUrl.address.required = false;
                        state.imagesDocsUrl.others.required = false;
                        state.objectPlan = {
                          id: planFound.Id,
                          publico: 'Funcionário de Empresa',
                          name: planFound.Nome,
                          registro: '',
                          fantasyName: result.data[0].NomeFantazia,
                          corporateName: result.data[0].RazaoSocial,
                          codeCompany: result.data[0].Id,
                        };
                        state.showMatricula = true;
                        state.fieldStep1.matriculaFm.required = true;
                        state.showAdmissionDateFm = true;
                        state.fieldStep1.admissionDateFm.required = true;
                        state.fieldStep1.admissionDateFm.value = null;
        
                        this.setState(state);
                      }
                      else {
                        let state = this.state;
                        state.showPage = false;
                        this.setError('Plano não encontrados para esta empresa');
                      }
                    }
                    else {
                      let state = this.state;
                      state.showPage = false;
                      this.setError('Planos não encontrados para esta empresa');
                    }
                  }
                  else {
                    let state = this.state;
                    state.showPage = false;
                    this.setError('Planos não encontrados para esta empresa');
                  }
                })
                .catch(function () {
                  let state = this.state;
                  state.showPage = false;
                  this.setError('Problema encontrado ao buscar planos da empresa');
                }.bind(this));
              }
              else {
                let state = this.state;
                state.showPage = false;
                this.setError('Situação da empresa: '+result.data[0].NomeSituacao);
              }
            }
            else {
              let state = this.state;
              state.showPage = false;
              this.setError('Plano não encontrados para esta empresa');
            }
          }
          else {
            let state = this.state;
            state.showPage = false;
            this.setError('Plano não encontrados para esta empresa');
          }
        })
        .catch(function () {
          let state = this.state;
          state.showPage = false;
          this.setError('Problema encontrado ao buscar planos da empresa');
        }.bind(this));
      }
      else {
        let state = this.state;
        state.showPage = false;
        this.setError('O plano deverá ser selecionado antes de iniciar');
      }
    }
    else {
      let state = this.state;
      state.showPage = false;
      this.setError('O plano deverá ser selecionado antes de iniciar');
    }
  }

  async getDataInfo() {
    // Pega características do vendedor
    let idSalesman = localStorage.getItem('planos_sl');

    axios.get(configBase.api + 'Salesmans?filter={"where":{"id":"'+idSalesman+'"},"include":["broker","user"]}&access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      let state = this.state;
      state.salesmanId = result.data[0].id;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar dados do vendedor');
    }.bind(this));
  }

  async getStates(){
    // Pega a lista de estados
    axios.get(configBase.api + 'APIS4s/UFs?access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      let state = this.state;
      state.stateList = result.data;

      // Pega a lista de tipos de logradouros
      axios.get(configBase.api + 'APIS4s/tipoLogradouro?access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        state.addressTypeList = result.data;
        this.setState(state);
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar a lista dos tipos de logradouro');
      }.bind(this));
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de estados');
    }.bind(this));
  }

  async getCurrentTimeServer() {
    // Pega a data atual do servidor
    axios.post(configBase.api + 'Sales/currentTime?access_token='+localStorage.getItem('planos_t'))
    .then((response) => {
      let state = this.state;
      let day = response.data.day;
      let month = response.data.month;
      state.currentTimeServer = response.data;

      if (response.data.day < 10)
        day = '0'+ day;
      if (response.data.month < 10)
        month = '0'+ month;

      // Data de Adesão
      state.fieldStep1.dateSignatureContractFm.value = response.data.year+'-'+month+'-'+day;

      // Para data de Admissão
      state.fieldStep1.admissionDateFm.value = day+'/'+month+'/'+response.data.year;

      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar data e hora corretos');
    }.bind(this));
  }

  showButtons(step=null) {
    let state = this.state;

    if (step !== null)
      state.stepper = this.state.stepper;

    if (state.stepper >= 1) {
      if (state.stepper === 1) {// Passo 2
        state.showButtonBack = true;
        state.showButtonFinished = false;
        state.showButtonNext = true;
        state.showButtonPrint = false;
      }
      else if (state.stepper === 2) {// Passo 3
        state.showButtonBack = true;
        state.showButtonFinished = false;
        state.showButtonNext = true;
        state.showButtonPrint = false;
      }
      else if (state.stepper === 3) {// Passo 4
        state.showButtonBack = true;
        state.showButtonFinished = true;
        state.showButtonNext = false;
        state.showButtonPrint = false;
      }
    }
    else {// Passo 1
      state.showButtonBack = false;
      state.showButtonFinished = false;
      state.showButtonNext = true;
      state.showButtonPrint = false;
    }

    this.setState(state);
  }

  nextStep() {
    let state = this.state;

    if (state.stepper === 0)// Do passo 1 para o passo 2
      this.checkFieldStep1();
    else if (state.stepper === 1)// Do passo 2 para o passo 3
      this.checkFieldStep2();
    else if (state.stepper === 2)// Do passo 3 para o passo 4
      this.checkFieldStep3();
    else
      this.showButtons(null);

    this.setState(state);
  }

  backStep() {
    let state = this.state;
    state.stepper = state.stepper - 1;
    this.showButtons(state.stepper);
    this.setState(state);
  }

  checkFieldStep1() {
    let data = this.state.fieldStep1;
    let state = this.state;
    let error = false;

    // Verifica idade do titular
    this.validateAgeCpfHolder();

    // Verifica obrigatoriedade
    Object.keys(data).forEach(function(key) {
      if (state.fieldStep1[key].error.length === 0) {
        if (data[key].model === 'financialManager') {
          if (data[key].required === true) {
            if (data[key].value !== null) {
              if (data[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length === 0) {
                state.fieldStep1[key].error = "Obrigatório";
                error = true;
              }
            }
            else {
              state.fieldStep1[key].error = "Obrigatório";
              error = true;
            }
          }
        }
        else {
          if (state.showFormHolder === true) {
            if (data[key].required === true) {
              if (data[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length === 0) {
                state.fieldStep1[key].error = "Obrigatório";
                error = true;
              }
            }
          }
        }
      }
      else
        error = true;
    });

    if (error === false) {
      state.stepper = state.stepper + 1;
      this.showButtons(state.stepper);

      // Para tela de benecifiários (tabela)
      if (state.stepper === 1 && state.showScriptTable === false) {
        // Atualiza o valor do titular apenas no primeiro acesso à primeira parte do formulário.
        // Caso vá para a próxima parte e depois retorne, não chamará essa função
        if (state.primeiroAcessoPasso1 === true)
          this.addHolderListDependent();

        this.showScriptTableFn();
      }
    }
    else
      this.setError('Campos com erro');

    this.setState(state);
  }

  validateAgeCpfHolder() {
    let state = this.state;
    if (this.state.showFormHolder === true) {// Resp Financeiro não é o titular
      if(this.state.fieldStep1.dateOfBirthHol.value !== null) {
        if (this.getAge(this.state.fieldStep1.dateOfBirthHol.value) > 12) {// CPF é obrigatório
          if (this.state.fieldStep1.cpfHol.value.replace(/[^\d]+/g,"").length !== 11) {
            state.fieldStep1.cpfHol.required = true;
            state.fieldStep1.cpfHol.error = 'Maior de 12 anos o CPF é obrigatório';
          }
        }
        else {
          state.fieldStep1.cpfHol.required = false;
          state.fieldStep1.cpfHol.error = '';
        }
      }
    }

    this.setState(state);
  }

  validateCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;
    if (cpf.length !== 11 || 
        cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999"){
      test = false;
    }
    else {
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11){
          rev = 0;
        }
        if (rev !== parseInt(cpf.charAt(9))){
          test = false;
        }
      add = 0;
      for (i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11){
        rev = 0;
      }
      if (rev !== parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test === true)
      return true;
    else
      return false;
  }

  countFinancialManager() {
    let cpf = this.state.fieldStep1.cpfFm.value.replace(/[^\d]+/g,"");
    let url = configBase.api + 'ImagesDocs/getImagesByCpf?access_token='+localStorage.getItem('planos_t');

    let dataSubmit = {
      cpf: cpf
    };

    if (cpf.length > 0) {
      let state = this.state;
      state.fieldStep1.cpfFm.loading = true;
      state.disabledNextButton = true;
      state.colorNextButton = '#ccc';
      this.setState(state);

      if (this.validateCpf(cpf) === true) {
        axios.post(url, dataSubmit)
        .then((response) => {
          let state = this.state;
          // Se existir uma venda completa com o mesmo cpf
          if (response.data.fullSale === true) {
            state.fieldStep1.cpfFm.error = "CPF já cadastrado";
            state.fieldStep1.cpfFm.loading = false;
            this.setState(state);
          }
          else {
            url = configBase.api + 'APIS4s/AssociadosV2?access_token='+localStorage.getItem('planos_t');
            dataSubmit = {
              cpfDependente: cpf
            };

            axios.post(url, dataSubmit)
            .then((response2) => {
              // Verifica se está inadimplente
              if (response2.data.inadimplente)
                state.fieldStep1.cpfFm.error = "CPF consta como inadimplente";
              else {
                state.fieldStep1.cpfFm.error = "";
                state.disabledNextButton = false;
                state.colorNextButton = configBase.corPrincipal;
              }

              state.fieldStep1.cpfFm.loading = false;
              this.setState(state);
            })
            .catch(function () {
              let state = this.state;
              state.fieldStep1.cpfFm.error = "Tente novamente";
              state.fieldStep1.cpfFm.loading = false;
              this.setError('Problema encontrado ao verificar CPF');
            }.bind(this));
          }
        })
        .catch(function () {
          let state = this.state;
          state.fieldStep1.cpfFm.error = "Tente novamente";
          state.fieldStep1.cpfFm.loading = false;
          this.setError('Problema encontrado ao verificar CPF');
        }.bind(this));
      }
      else {
        let state = this.state;
        state.fieldStep1.cpfFm.error = "CPF inválido";
        state.fieldStep1.cpfFm.loading = false;
        this.setState(state);
      }
    }
  }

  updateFieldStep1(event) {
    let state = this.state;
    state.fieldStep1[event.target.name].value = event.target.value;
    state.fieldStep1[event.target.name].error = '';
    this.setState(state);

    // Apenas letras
    if (state.fieldStep1[event.target.name].type === 'text')
      this.validateLetters(event.target.value, event.target.name, 'fieldStep1');
    else if (state.fieldStep1[event.target.name].type === 'number')
      this.validateNumber(state.fieldStep1[event.target.name].value, event.target.name, 'fieldStep1');

    if (event.target.name === 'cepFm')
      this.getAddress();
    else if (event.target.name === 'stateFm')
      this.getCity(null);
    else if (event.target.name === 'cityFm')
      this.beforeGetDistrict(null);
  }

  validateLetters(text, field, stepData) {
    let nameReg = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

    if (text.length > 0) {
      if (!nameReg.test(text)) {
        let state = this.state;
        if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Apenas letras';
        else if (stepData === 'dependent')
          state.dependent[this.state.depIndex][field].error = 'Apenas letras';

        this.setState(state);
      }
    }
  }

  validateTel(field) {
    let tel = this.state.fieldStep1[field].value;
    let telLength = tel.replace(/[^0-9]/g, '').length;

    if (telLength > 0) {
      if (telLength !== 10) {
        let state = this.state;
        state.fieldStep1[field].error = 'Número de telefone inválido';
        this.setState(state);
      }
    }
  }

  validateCell(field) {
    let tel = this.state.fieldStep1[field].value;
    let telLength = tel.replace(/[^0-9]/g, '').length;

    if (telLength > 0) {
      if (telLength !== 11) {
        let state = this.state;
        state.fieldStep1[field].error = 'Número de celular inválido';
        this.setState(state);
      }
    }
  }

  validateNumber(number, field, stepData) {
    let numberReg = /^[0-9/ ]+$/;
    //number = number.toString().replace(/[^\d]+/g,"");

    if (number.length > 0) {
      if(!numberReg.test(number)) {
        let state = this.state;
        if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Apenas números';
        else if (stepData === 'dependent')
          state.dependent[this.state.depIndex][field].error = 'Apenas números';
        this.setState(state);
      }
    }
  }

  validateSus(stepData, field) {
    let sus = '';
    let susLength = 0;

    if (stepData === 'fieldStep1')
      sus = this.state.fieldStep1[field].value;
    else if (stepData === 'dependent')
      sus = this.state.dependent[this.state.depIndex][field].value;

    susLength = sus.replace(/[^0-9]/g, '').length

    if (susLength > 0) {
      if (susLength !== 15) {
        let state = this.state;
        if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Cartão do SUS deve possuir 15 dígitos';
        else if (stepData === 'dependent')
          state.dependent[this.state.depIndex][field].error = 'Cartão do SUS deve possuir 15 dígitos';
        this.setState(state);
      }
    }
  }

  countFinancialManagerEmail() {
    let email = this.state.fieldStep1.emailFm.value;
    //let url = configBase.api + 'FinancialManagers?filter={"where":{"email":{"like":"'+email+'","options":"i"}}}&access_token='+localStorage.getItem('planos_t');
    //let state = this.state;
    //state.fieldStep1.emailFm.loading = true;
    //this.setState(state);

    if (this.validateEmail(email) === true) {
      /* axios.get(url)
      .then((response) => {
        let state = this.state;
        
        for (let i = 0; i < response.data.length; i++) {
          // Verifica se está cancelada
          if (response.data[i].protocoloCancelamento !== undefined && response.data[i].protocoloCancelamento.length > 0)
            state.fieldStep1.emailFm.error = "";
          else
            state.fieldStep1.emailFm.error = "E-mail já cadastrado";
        }

        state.fieldStep1.emailFm.loading = false;
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.fieldStep1.emailFm.error = "Tente novamente";
        state.fieldStep1.emailFm.loading = false;
        this.setError('Problema encontrado ao verificar E-mail');
      }.bind(this)); */
    }
    else {
      let state = this.state;
      state.fieldStep1.emailFm.error = "E-mail inválido";
      state.fieldStep1.emailFm.loading = false;
      this.setState(state);
    }
  }

  validateEmail(email) {
    let emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if(!emailReg.test(email) || email === ""){
      return false;
    }else{
      return true;
    }
  }

  updateFieldDate(stepData, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    if (stepData === 'dependent')
      state.dependent[this.state.depIndex][field].error = '';
    else if (stepData === 'fieldStep1')
      state.fieldStep1[field].error = '';

    this.setState(state);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (value.getTime() !== 0) {
        day = value.getDate();
        month = value.getMonth() + 1;
        year = value.getFullYear();;

        if (day < 10)
          day = '0'+ day;
        if (month < 10)
          month = '0'+ month;

        if (stepData === 'dependent')
          state.dependent[this.state.depIndex][field].value = year+'-'+month+'-'+day;
        else if (stepData === 'fieldStep1')
          state.fieldStep1[field].value = year+'-'+month+'-'+day;

        this.validateDate(day+'/'+month+'/'+year, field, stepData);
      }
      else {
        if (stepData === 'dependent') {
          state.dependent[this.state.depIndex][field].value = value;
          state.dependent[this.state.depIndex][field].error = 'Data inválida';
        }
        else if (stepData === 'fieldStep1') {
          state.fieldStep1[field].value = value;
          state.fieldStep1[field].error = 'Data inválida';
        }
      }
    }
    else {
      if (stepData === 'dependent') {
        state.dependent[this.state.depIndex][field].value = value;
        state.dependent[this.state.depIndex][field].error = 'Data inválida';
      }
      else if (stepData === 'fieldStep1') {
        state.fieldStep1[field].value = value;
        state.fieldStep1[field].error = 'Data inválida';
      }
    }

    this.setState(state);
  }

  validateDate(date, field, stepData) {
    let dateReg = /^((((0?[1-9]|[12]\d|3[01])[.\-/](0?[13578]|1[02])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[.\-/](0?[13456789]|1[012])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|(29[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (date.length > 0) {
      if(!dateReg.test(date)) {
        let state = this.state;
        if (stepData === 'dependent')
          state.dependent[this.state.depIndex][field].error = 'Data inválida';
        else if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Data inválida';


        this.setState(state);
      }
    }
  }

  getAddress() {
    let valueCep = this.state.fieldStep1.cepFm.value.replace(/[^\d]+/g,"");

    if (valueCep.length >= 8) {
      let state = this.state;
      state.fieldStep1.addressNumberFm.error = '';
      state.fieldStep1.addressTypeFm.loading = true;
      state.fieldStep1.addressTypeFm.error = '';
      state.fieldStep1.addressFm.loading = true;
      state.fieldStep1.addressFm.error = '';
      state.fieldStep1.stateFm.loading = true;
      state.fieldStep1.stateFm.error = '';
      state.fieldStep1.cityFm.loading = true;
      state.fieldStep1.cityFm.error = '';
      state.fieldStep1.districtFm.loading = true;
      state.fieldStep1.districtFm.error = '';
      this.setState(state);

      let dataPost = {
        'cep': valueCep
      };

      axios.post(configBase.api + 'APIS4s/Endereco?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        if (result.data !== null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.fieldStep1.addressTypeFm.value = result.data.IdTipoLogradouro;
          state.fieldStep1.addressFm.value = result.data.Logradouro;
          state.fieldStep1.stateFm.value = result.data.IdUf;
          this.setState(state);

          this.getCity(function (stateCity) {
            stateCity.fieldStep1.cityFm.value = result.data.IdMunicipio;
            this.setState(stateCity);

            this.beforeGetDistrict(function (stateDistrict) {
              stateDistrict.fieldStep1.districtFm.value = result.data.IdBairro;

              state.fieldStep1.addressTypeFm.loading = false;
              state.fieldStep1.addressFm.loading = false;
              state.fieldStep1.addressNumberFm.loading = false;
              state.fieldStep1.stateFm.loading = false;
              state.fieldStep1.cityFm.loading = false;
              state.fieldStep1.districtFm.loading = false;
              this.setState(stateDistrict);
              document.getElementById('i_addressNumberFm').focus();
            }.bind(this));
          }.bind(this));
        }
        else {
          let state = this.state;
          state.fieldStep1.addressTypeFm.loading = false;
          state.fieldStep1.addressFm.loading = false;
          state.fieldStep1.addressNumberFm.loading = false;
          state.fieldStep1.stateFm.loading = false;
          state.fieldStep1.cityFm.loading = false;
          state.fieldStep1.districtFm.loading = false;
          state.fieldStep1.cepFm.error = '';

          state.fieldStep1.addressTypeFm.value = 'null';
          state.fieldStep1.addressFm.value = '';
          state.fieldStep1.addressNumberFm.value = '0';
          state.fieldStep1.stateFm.value = 'null';
          state.fieldStep1.cityFm.value = 'null';
          state.fieldStep1.districtFm.value = 'null';
          this.setError('CEP não encontrado');
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar endereço pelo CEP');
      }.bind(this));
    }
  }

  getCity(cb=null) {
    let state = this.state;
    state.fieldStep1.cityFm.value = 'null';
    state.fieldStep1.districtFm.value = 'null';
    this.setState(state);

    let chosenState = 0;
    chosenState = this.state.fieldStep1.stateFm.value;

    if (cb === null) {
      let state = this.state;
      state.fieldStep1.cityFm.loading = true;
      state.fieldStep1.districtFm.loading = true;
      state.cityList = [];
      state.districtList = [];
      this.setState(state);
    }

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;

      if (cb !== null) {
        this.setState(state);
        cb(state);
      }
      else {
        state.fieldStep1.cityFm.loading = false;
        state.fieldStep1.districtFm.loading = false;
        this.setState(state);
      }
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado');
    }.bind(this));
  }

  beforeGetDistrict(cb=null) {
    /* let state = this.state;
    state.fieldStep1.districtFm.value = 'null';
    this.setState(state);

    if (this.state.objectPlan.publico !== 'Funcionário de Empresa') {

      axios.get(configBase.api + 'Abrangencia?filter={"where":{"Municipios":{"inq":['+this.state.fieldStep1.cityFm.value+']}}}&access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        if (result.data.length > 0) {
          let abrangenciaId = result.data[0].id;

          axios.get(configBase.api + 'Plans?filter={"where":{"abrangenciaId":"'+abrangenciaId+'"}}&access_token='+localStorage.getItem('planos_t'))
          .then((result2) => {
            if (result2.data.length > 0) {
              let state = this.state;
              let plan = false;

              for (let i = 0; i < result2.data.length; i++) {
                // Caso o Plano do formulário esteja na lista de planos para essa cidade
                if (result2.data[i].id === this.state.objectPlan.id) {
                  plan = true;
                  break;
                }
              }

              if (plan === false) {
                state.fieldStep1.addressFm.error = 'O endereço informado não está dentro do local de utilização selecionado para o plano!';
                this.setError('O endereço informado não está dentro do local de utilização selecionado para o plano!');
              }
              else
                state.fieldStep1.addressFm.error = '';

              this.setState(state);
              this.getDistrict(cb);
            }
            else {
              let state = this.state;
              state.fieldStep1.addressFm.error = 'Planos não encontrados dentro desse local de utilização selecionado';
              this.setState(state);
              this.setError('Planos não encontrados dentro desse local de utilização selecionado');
            }
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar lista de bairros pela cidade');
          }.bind(this));
        }
        else {
          let state = this.state;
          state.fieldStep1.addressFm.error = 'Planos não encontrados dentro desse local de utilização selecionado';
          this.setState(state);
          this.setError('Planos não encontrados dentro desse local de utilização selecionado');
        }
      })
      .catch(function () {
        let state = this.state;
        state.disabledCity = false;
        this.setError('Problema encontrado ao buscar lista de bairros pela cidade');
      }.bind(this));
    }
    else */
      this.getDistrict(cb);
  }

  getDistrict(cb=null) {
    let chosenCity = 0;
    chosenCity = this.state.fieldStep1.cityFm.value;

    if (cb === null) {
      let state = this.state;
      state.fieldStep1.districtFm.loading = true;
      state.districtList = [];
      this.setState(state);
    }

    let dataPost = {
      idCity: parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;

      if (cb !== null) {
        this.setState(state);
        cb(state);
      }
      else {
        state.fieldStep1.districtFm.loading = false;
        this.setState(state);
      }
    })
    .catch(function (error) {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade');
    }.bind(this));
  }

  reteveAdesaoOn() {
    let state = this.state;
    state.fieldStep1.reteveAdesao.value = true;
    this.setWarning('Adesão retida pelo vendedor')
    this.setState(state);
  }

  reteveAdesaoOff() {
    let state = this.state;
    state.fieldStep1.reteveAdesao.value = false;
    this.setState(state);
  }

  showFormHolderOn() {
    let state = this.state;
    state.showFormHolder = true;
    this.setState(state);
  }

  showFormHolderOff() {
    let state = this.state;
    state.showFormHolder = false;
    this.setState(state);
  }

  updateFieldDependents(event) {
    let state = this.state;
    state.dependent[this.state.depIndex][event.target.name].value = event.target.value;
    state.dependent[this.state.depIndex][event.target.name].error = '';
    this.setState(state);

    // Apenas letras
    if (state.dependent[this.state.depIndex][event.target.name].type === 'text')
      this.validateLetters(event.target.value, event.target.name, 'dependent');
    else if (state.dependent[this.state.depIndex][event.target.name].type === 'number')
      this.validateNumber(state.dependent[this.state.depIndex][event.target.name].value, event.target.name, 'dependent');
  }

  showScriptTableFn() {
    $(document).ready( function () {
      let table = $('#table_id').DataTable({
        "dom": 'rtip',// Exibe {processing}{table}{information}{pagination}
        "language": {
          "url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
        },
        "infoCallback": function( settings, start, end, max, total, pre ) {// Quantidade por página
          document.getElementById('tablePageStart').innerHTML = start;
          document.getElementById('tablePageEnd').innerHTML = end;
          document.getElementById('tablePageTotal').innerHTML = total;
          return '';
        },
        pagingType: "simple",
        oLanguage: {
          oPaginate: {
            sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
            sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
          },
        },
        "scrollX": true,
      });

      // Quantidade por página
      $('#myLengthMenu').on( 'change', function () {
        table.page.len($('#myLengthMenu').val()).draw();
      } );
    });
  }

  addHolderListDependent() {
    let state = this.state;
    let dep = {
      firstName: '',
      isHolder: true,
      valuePlan: this.state.objectPlan.value,
      namePlan: this.state.objectPlan.name,
      qualificacao: this.state.objectPlan.qualificacao,
      registro: this.state.objectPlan.registro,
    };

    if (state.dependentsList.length > 0) {
      for (let i = 0; i < state.dependentsList.length; i++) {
        if (state.dependentsList[i].isHolder === true) {
          // O Resp Financeiro NÃO É o titular do plano
          if (this.state.showFormHolder === true)
            dep.firstName = this.state.fieldStep1.firstNameHol.value;
          // O Resp Financeiro É o titular do plano
          else
            dep.firstName = this.state.fieldStep1.firstNameFm.value;

          state.dependentsList[i] = dep;
          break;
        }
      }
    }
    else {
      // O Resp Financeiro NÃO É o titular do plano
      if (this.state.showFormHolder === true)
        dep.firstName = this.state.fieldStep1.firstNameHol.value;
      // O Resp Financeiro É o titular do plano
      else
        dep.firstName = this.state.fieldStep1.firstNameFm.value;

      state.dependentsList.push(dep);
    }

    state.primeiroAcessoPasso1 = false;

    this.setState(state);
  }

  checkFormDependent() {
    let state = this.state;
    let error = false;
    let depIndex = this.state.depIndex;
    //let requiredCpfAge = false;

    // Se for maior de 12 anos o CPF torna-se obrigatório
    /* if (this.state.dependent[depIndex].dateOfBirth.value !== null) {
      if (this.getAge(this.state.dependent[depIndex].dateOfBirth.value) > 12) {
        requiredCpfAge = true;
        state.dependent[depIndex].cpf.required = true;
      }
      else
        state.dependent[depIndex].cpf.required = false;
    } */

    let data = state.dependent[depIndex];

    Object.keys(data).forEach(function(key) {
      if (state.dependent[depIndex][key].error.length === 0) {
        // Se o campo for obrigatório
        if (data[key].required === true) {
          if (data[key].value !== null) {
            if (data[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length === 0) {
              /* if (key === 'cpf' && requiredCpfAge === true)
                state.dependent[depIndex][key].error = "Maior de 12 anos o CPF é obrigatório";
              else */
                state.dependent[depIndex][key].error = "Obrigatório";

              error = true;
            }
          }
          else {
            state.dependent[depIndex][key].error = "Obrigatório";
            error = true;
          }
        }
      }
      else
        error = true;
    });
    
    if (error === false)
      this.addDependentList();//Add dependente na lista e na tabela
    else
      this.setError('Campos com erro');
  }

  async validateAllCpf(stepData, field) {
    let state = this.state;
    let depIndex = this.state.depIndex;
    let error = false;
    let cpf = '';

    if (stepData === 'fieldStep1')
      cpf = state.fieldStep1[field].value;
    else if (stepData === 'dependent')
      cpf = state.dependent[depIndex][field].value;

    if (cpf.replace(/[^\d]+/g,"") > 0) {
      if (this.validateCpf(cpf) === true) {
        // Verifica se é igual ao CPF do Resp Financeiro
        if (cpf === this.state.fieldStep1.cpfFm.value) {
          if (stepData === 'fieldStep1') {
            error = true;
            state.fieldStep1[field].error = 'CPF igual ao do Resp. Financeiro';
          }
          else if (stepData === 'dependent') {
            error = true;
            state.dependent[depIndex][field].error = 'CPF igual ao do Resp. Financeiro';
          }
        }
        else {
          if (stepData === 'dependent') {
            // Verifica se é igual ao CPF do titular
            if (cpf === state.fieldStep1.cpfHol.value) {
              error = true;
              state.dependent[depIndex][field].error = 'CPF igual ao do Titular do plano';
            }
  
            // Verifica se é igual ao de outros dependetes
            for (let i = 0; i < state.dependent.length; i++) {
              // Exclui o atual dependete que ainda está no form
              if (i !== this.state.depIndex) {
                if (state.dependent[i].cpf.value.replace(/[^\d]+/g,"").length > 0 && cpf === state.dependent[i].cpf.value) {
                  error = true;
                  state.dependent[depIndex][field].error = 'Beneficiários com mesmo CPF';
                }
              }
            }
          }
        }
      }
      else {
        if (stepData === 'fieldStep1') {
          error = true;
          state.fieldStep1[field].error = 'CPF inválido';
        }
        else if (stepData === 'dependent') {
          error = true;
          state.dependent[depIndex][field].error = 'CPF inválido';
        }
      }
    }

    this.setState(state);

    // Mesma checagem de restrição/inadimplência que já roda no CPF do
    // responsável financeiro (countFinancialManager), agora pro titular e
    // pros dependentes - sem isso dava pra burlar cadastrando o titular ou
    // dependente inadimplente sob um responsável financeiro limpo.
    if (!error && cpf.replace(/[^\d]+/g,"").length === 11) {
      let target = stepData === 'fieldStep1' ? state.fieldStep1[field] : state.dependent[depIndex][field];

      target.loading = true;
      this.setState(state);

      try {
        let response = await axios.post(
          configBase.api + 'APIS4s/AssociadosV2?access_token=' + localStorage.getItem('planos_t'),
          {cpfDependente: cpf.replace(/[^\d]+/g,"")}
        );

        if (response.data && response.data.inadimplente) {
          error = true;
          target.error = 'CPF consta como inadimplente';
        }
      }
      catch (e) {
        // Segue sem bloquear se a consulta falhar - mesma tolerância das
        // outras checagens de CPF nesse formulário.
      }

      target.loading = false;
      this.setState(state);
    }

    return !error;
  }

  addDependentList() {
    let state = this.state;
    let dep = {
      isHolder: false,
      firstName: this.state.dependent[this.state.depIndex].firstName.value,
      valuePlan: '',
      namePlan: '',
      qualificacao: '',
      registro: '',
    };
    let defaultDependent = {
      firstName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
      susNumber: {value: '', required: false, error: '', model: 'dependent', type: 'number'},
      motherName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
      cpf: {value: '', required: true, error: '', model: 'dependent', type: ''},
      dateOfBirth: {value: null, required: true, error: '', model: 'dependent', type: 'date'},
      maritalStatus: {value: 'null', required: true, error: '', model: 'dependent', type: 'text'},
      gender: {value: 'null', required: true, error: '', model: 'dependent', type: 'number'},
      parentage: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
      isHolder: {value: false, required: true, error: '', model: 'dependent', type: 'text'},
      plansId: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
      valuePlan: {value: 'null', required: false, error: '', model: 'dependent', type: ''},
    };

    // Seta o nome do plano no dependente
    for (let i = 0; i < this.state.plansListFull.length; i++) {
      if (this.state.dependent[this.state.depIndex].plansId.value === this.state.plansListFull[i].id) {
        dep.namePlan = this.state.plansListFull[i].name;
        dep.qualificacao = this.state.plansListFull[i].qualificacao;
        dep.registro = this.state.plansListFull[i].registro;
      }
    }
    
    // Quando for uma edição
    if (state.editDependent.status === true) {
      // Atualiza a tabela de dependentes
      state.dependentsList[state.editDependent.index] = dep;
      state.editDependent.status = false;
      state.depIndex = state.dependent.length - 1;
      state.dependent[state.depIndex] = defaultDependent;
      this.setState(state);
      this.updateValueTotal();//atualiza valor do plano.
    }
    // Quando não for uma edição
    else {
      // Atualiza a tabela de dependentes
      state.dependentsList.push(dep);
      state.dependent.push(defaultDependent);
      state.depIndex = state.depIndex + 1;
      this.updateValueTotal();//atualiza valor do plano.
    }

  }

  updateValueTotal() {
    let state = this.state;

    // Para planos salvos no banco S4E
    if (this.state.objectPlan.publico === 'Funcionário de Empresa') {
      // Quantidade de dependentes
      let countDep = this.state.dependentsList.length - 1;
      let valueDep = countDep * (parseFloat(state.value_dependent.replace(',', '.')));

      // valor total = valor titular + valor dos dependentes
      state.value_total = ((parseFloat(state.value_holder.replace(',', '.'))) + valueDep).toFixed(2).replace('.', ',');
    }
    // Para planos salvos no banco Intelite
    else {
      // Percorre a lista de dependentes
      for (let i = 0; i < this.state.dependent.length - 1; i++) {
        if (this.state.objectPlan.id !== this.state.dependent[i].plansId.value) {
          state.differentPlans = true;
          break;
        }
      }

      // Caso os planos dos dependentes sejam iguais ao plano principal
      /* if (state.differentPlans === false) {
        state.value_total = state.objectPlan.value;

        if (this.state.dependentsList.length === 1) {
          state.lastValue = state.objectPlan.value;
          state.value_total = state.objectPlan.value;
          state.valueIndividualPlan = state.objectPlan.value;
        }
        else if (this.state.dependentsList.length === 2) {
          if (state.objectPlan.familyTable.value2) {
            state.lastValue = state.objectPlan.familyTable.value2;
            state.value_total = parseFloat(state.objectPlan.familyTable.value2.replace(',','.')) * 2;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.objectPlan.familyTable.value2;
          }
          else {
            state.value_total = parseFloat(state.lastValue.replace(',','.')) * 2;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.lastValue;
          }
        }
        else if (this.state.dependentsList.length === 3) {
          if (state.objectPlan.familyTable.value3) {
            state.lastValue = state.objectPlan.familyTable.value3;
            state.value_total = parseFloat(state.objectPlan.familyTable.value3.replace(',','.')) * 3;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.objectPlan.familyTable.value3;
          }
          else {
            state.value_total = parseFloat(state.lastValue.replace(',','.')) * 3;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.lastValue;
          }
        }
        else if (this.state.dependentsList.length === 4) {
          if (state.objectPlan.familyTable.value4) {
            state.lastValue = state.objectPlan.familyTable.value4;
            state.value_total = parseFloat(state.objectPlan.familyTable.value4.replace(',','.')) * 4;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.objectPlan.familyTable.value4;
          }
          else {
            state.value_total = parseFloat(state.lastValue.replace(',','.')) * 4;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.lastValue;
          }
        }
        else if (this.state.dependentsList.length === 5) {
          if (state.objectPlan.familyTable.value5) {
            state.lastValue = state.objectPlan.familyTable.value5;
            state.value_total = parseFloat(state.objectPlan.familyTable.value5.replace(',','.')) * 5;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.objectPlan.familyTable.value5;
          }
          else {
            state.value_total = parseFloat(state.lastValue.replace(',','.')) * 5;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.lastValue;
          }
        }
        else if (this.state.dependentsList.length >= 6) {
          if (state.objectPlan.familyTable.value6) {
            state.lastValue = state.objectPlan.familyTable.value6;
            state.value_total = parseFloat(state.objectPlan.familyTable.value6.replace(',','.')) * this.state.dependentsList.length;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.objectPlan.familyTable.value6;
          }
          else {
            state.value_total = parseFloat(state.lastValue.replace(',','.')) * this.state.dependentsList.length;
            state.value_total = state.value_total.toFixed(2).replace('.', ',');
            state.valueIndividualPlan = state.lastValue;
          }
        }

        state.value_total = ((parseFloat(state.value_total.replace(',', '.')) +
          parseFloat(state.implantationRate.replace(',', '.')))).toFixed(2).toString().replace('.', ',');

        // Atualiza os valores dos dependentes na tabela de dependentes
        for (let i = 0; i < this.state.dependent.length - 1; i++) {
          state.dependentsList[i+1].valuePlan = state.valueIndividualPlan;
        }
      }
      // Caso os planos dos dependentes sejam diferentes do plano principal
      else { */
        let configFT = {
          2: 'value2',
          3: 'value3',
          4: 'value4',
          5: 'value5',
          6: 'value6',
        };
        //let qtdDeps = this.state.dependentsList.length;
        let qtdDepsTabelaFamilia = 0;

        state.value_total = 0;

        // Calcula a quantidade de dependentes com planos familiar
        for (let i = 0; i < this.state.dependentsList.length; i++) {
          if (this.state.dependentsList[i].qualificacao === 'Familiar')
            qtdDepsTabelaFamilia += 1;
        }

        // Calcula o valor total baseado no valor do plano individualmente
        for (let i = 0; i < this.state.dependent.length - 1; i++) {
          for (let f = 0; f < this.state.plansListFull.length; f++) {
            if (this.state.dependent[i].plansId.value === this.state.plansListFull[f].id) {
              if (qtdDepsTabelaFamilia < 2)
                state.dependent[i].valuePlan.value = this.state.plansListFull[f].value;
              else {
                if (this.state.plansListFull[f].familyTable[configFT[qtdDepsTabelaFamilia]]) {
                  if (this.state.plansListFull[f].qualificacao === 'Familiar')
                    state.dependent[i].valuePlan.value = this.state.plansListFull[f].familyTable[configFT[qtdDepsTabelaFamilia]];
                  else
                    state.dependent[i].valuePlan.value = this.state.plansListFull[f].value;
                }
                else {
                  state.dependent[i].valuePlan.value = null;

                  for (let g = qtdDepsTabelaFamilia; g < 2; g--) {
                    if (this.state.plansListFull[f].familyTable[configFT[g]] && this.state.plansListFull[f].qualificacao === 'Familiar') {
                      state.dependent[i].valuePlan.value = this.state.plansListFull[f].familyTable[configFT[g]];
                      break;
                    }
                  }

                  if (state.dependent[i].valuePlan.value === null)
                    state.dependent[i].valuePlan.value = this.state.plansListFull[f].value;
                }
              }

              state.value_total = state.value_total + parseFloat(state.dependent[i].valuePlan.value.replace(',','.'));
            }
          }
        }

        // Soma com o valor do titular
        let valorTitular = this.updateValueHolder();
        state.value_total = state.value_total + parseFloat(valorTitular.replace(',', '.'));
        state.value_total = state.value_total.toFixed(2).replace('.', ',');

        // Atualiza os valores dos dependentes na tabela de dependentes
        for (let i = 0; i < this.state.dependent.length - 1; i++) {
          state.dependentsList[i+1].valuePlan = state.dependent[i].valuePlan.value;
        }
      //}
    }

    this.setState(state);
  }

  updateValueHolder() {
    let state = this.state;
    let qtdDeps = state.dependentsList.length;
    let qtdDepsTabelaFamilia = 0;
    let planoCompleto = state.objectPlan;
    let valorParaRetornar = '';
    let configFT = {
      2: 'value2',
      3: 'value3',
      4: 'value4',
      5: 'value5',
      6: 'value6',
    };

    for (let i = 0; i < this.state.dependentsList.length; i++) {
      if (this.state.dependentsList[i].qualificacao === 'Familiar')
        qtdDepsTabelaFamilia += 1;
    }

    for (let i = 0; i < qtdDeps; i++) {
      if (state.dependentsList[i].isHolder === true) {
        if (qtdDepsTabelaFamilia < 2)
          state.dependentsList[i].valuePlan = planoCompleto.value;
        else if (qtdDepsTabelaFamilia >= 2) {
          if (planoCompleto.familyTable[configFT[qtdDepsTabelaFamilia]])
            state.dependentsList[i].valuePlan = planoCompleto.familyTable[configFT[qtdDepsTabelaFamilia]];
          else {
            state.dependentsList[i].valuePlan = null;

            for (let g = qtdDepsTabelaFamilia; g < 2; g--) {
              if (planoCompleto.familyTable[configFT[g]]) {
                state.dependentsList[i].valuePlan = planoCompleto.familyTable[configFT[g]];
                break;
              }
            }

            if (state.dependentsList[i].valuePlan === null)
              state.dependentsList[i].valuePlan = planoCompleto.value;
          }
        }

        valorParaRetornar = state.dependentsList[i].valuePlan;
      }
    }

    this.setState(state);

    return valorParaRetornar;
  }

  getAge(date) {
    //verifica a idade para definir a obrigatoriedade do cpf
    let part = date.split('-'),
        dateIs = new Date(this.state.fieldStep1.dateSignatureContractFm.value),//data atual
        day = dateIs.getDate(),
        year = dateIs.getFullYear(),
        month = dateIs.getMonth() + 1;

    let age = '';

    age = year - part[0];

    if (month < parseInt(part[1]) || (month === parseInt(part[1]) && day < parseInt(part[2])))
      age--;

    return age;
  }

  deleteDependentList(index) {
    let state = this.state;
    state.dependentsList.splice(index, 1);
    state.dependent.splice(index - 1, 1);
    state.depIndex = state.dependent.length - 1;

    this.updateValueTotal();//atualiza valor do plano.
  }

  editDependentList(index) {
    let state = this.state;
    state.depIndex = index - 1;
    state.editDependent.status = true;
    state.editDependent.index = index;
    document.getElementById("i_dep_parentage").focus();
    this.setState(state);
  }

  checkFieldStep2() {
    let state = this.state;

    if (this.state.dependentsList.length === 1) {// Apenas o titular, exibe modal
      state.modalNoDependents = true;
      this.fullScreenModalFn();
    }
    else// Avança para o passo 3
      this.goStep3();

    this.setState(state);
  }

  goStep3() {
    let state = this.state;
    state.stepper = state.stepper + 1;
    this.showButtons(state.stepper);
    this.modalNoDependentsClose();
  }

  modalNoDependentsClose() {
    let state = this.state;
    state.modalNoDependents = false;
    this.setState(state);
  }

  dropzoneDialogOpen(typeFile=null) {
    let state = this.state;
    state.dropzoneDialog = true;

    if (typeFile !== null)
      state.typeFile = typeFile;

    this.setState(state);
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", address, cardCredit, hysicalContract, others
    */

    let reader = new FileReader();
    let file = files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    document.getElementById('imagem_'+state.typeFile).value = "";
    state.imagesDocsUrl[state.typeFile].error = '';

    if (ext === 'pdf')
      state.imagesDocsUrl[state.typeFile].url = "pdf";
    else 
      state.imagesDocsUrl[state.typeFile].url = window.URL.createObjectURL(file);

    this.dropzoneDialogClose();
    
    reader.onloadend = function() {
      document.getElementById('imagem_'+state.typeFile).value = reader.result;
    };

    reader.readAsDataURL(file);
  }

  checkFieldStep3() {
    let data = this.state.imagesDocsUrl;
    let error = false;
    let state = this.state;

    Object.keys(data).forEach(function(key) {
      if (data[key].required === true && document.getElementById('imagem_'+key).value === "") {
        state.imagesDocsUrl[key].error = 'Documento obrigatório';
        error = true;
      }
    });

    if (error === false) {
      state.stepper = state.stepper + 1;
      this.showButtons(state.stepper);
    }
    else
      this.setError('Campos com erro');

    this.setState(state);
  }

  addressTypeToResume() {
    for (let i = 0; i < this.state.addressTypeList.length; i++) {
      if (this.state.fieldStep1.addressTypeFm.value.toString() === this.state.addressTypeList[i].Id.toString()) {
        return this.state.addressTypeList[i].Nome;
      }
    }
  }

  stateToResume() {
    for (let i = 0; i < this.state.stateList.length; i++) {
      if (this.state.fieldStep1.stateFm.value.toString() === this.state.stateList[i].Id.toString()) {
        return this.state.stateList[i].Sigla;
      }
    }
  }

  cityToResume()  {
    for (let i = 0; i < this.state.cityList.length; i++) {
      if (this.state.fieldStep1.cityFm.value.toString() === this.state.cityList[i].Id.toString()) {
        return this.state.cityList[i].Nome;
      }
    }
  }

  districtToResume()  {
    for (let i = 0; i < this.state.districtList.length; i++) {
      if (this.state.fieldStep1.districtFm.value.toString() === this.state.districtList[i].Id.toString()) {
        return this.state.districtList[i].Nome;
      }
    }
  }

  finishedModalOpen() {
    let state = this.state;
    state.finishedModal = true;
    this.fullScreenModalFn();
    this.setState(state);
  }

  finishedModalClose() {
    let state = this.state;
    state.finishedModal = false;
    state.finishedModalMinWidth = 300;
    this.setState(state);
  }

  beforeSubmitForm() {
    let state = this.state;
    state.finishedLoading = true;

    if (state.fullScreenModal === false)
      state.finishedModalMinWidth = 600;

    this.setState(state);

    if (localStorage.getItem('planos_y') === 'SALESMAN') {
      let filter = 'Salesmans?filter={"where":{"userId":"' + localStorage.getItem('planos_u') +'"}}&access_token='+localStorage.getItem('planos_t');

      axios.get(configBase.api + filter)
      .then((response) => {
        this.onSubmitForm(response.data[0].id);
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar dados do vendedor');
      }.bind(this));
    }
    else {
      this.onSubmitForm(localStorage.getItem('planos_sl'));
      this.finishedModalClose();
    }
  }

  preparingFm() {
    let fm = {
      firstName: this.state.fieldStep1.firstNameFm.value,
      susNumber: this.state.fieldStep1.susNumberFm.value,
      email: this.state.fieldStep1.emailFm.value,
      homePhone: this.state.fieldStep1.homePhoneFm.value,
      cellPhone: this.state.fieldStep1.cellPhoneFm.value,
      cellPhone2: this.state.fieldStep1.cellPhone2Fm.value,
      motherName: this.state.fieldStep1.motherNameFm.value,
      cpf: this.state.fieldStep1.cpfFm.value,
      rg: this.state.fieldStep1.rgFm.value,
      rgEmitter: this.state.fieldStep1.rgEmitterFm.value,
      dateOfBirth: this.state.fieldStep1.dateOfBirthFm.value,
      maritalStatus: this.state.fieldStep1.maritalStatusFm.value,
      gender: this.state.fieldStep1.genderFm.value,
      cep: this.state.fieldStep1.cepFm.value,
      addressType: this.state.fieldStep1.addressTypeFm.value,
      address: this.state.fieldStep1.addressFm.value,
      matricula: '',
      admissionDate: '',
      addressNumber: this.state.fieldStep1.addressNumberFm.value,
      addressComplement: this.state.fieldStep1.addressComplementFm.value,
      district: this.state.fieldStep1.districtFm.value,
      city: this.state.fieldStep1.cityFm.value,
      state: this.state.fieldStep1.stateFm.value,
      lastName: '',
      responsibility: this.state.value_total.replace(',', '.'),
      contratanteTitular: !this.state.showFormHolder,
      dateSignatureContract: this.state.fieldStep1.dateSignatureContractFm.value,
      TypeFm: '',
      cidadeId: localStorage.getItem('fm_citySelect'),
      reteveAdesao: this.state.fieldStep1.reteveAdesao.value,
      ativaTermoAditivo: this.state.checkedAtivaTermoAditivo,
    };

    if (this.state.objectPlan.publico === 'Servidor') {
      fm.TypeFm = 'SERVIDOR';
      fm.orgaoAverbadorId = localStorage.getItem('planos_or');
      fm.qtdDependentes = this.state.dependentsList.length - 1;
      fm.formOfPayment = 'AVERBAÇÃO';

      // Para matrícula e data de Admissão
      fm.admissionDate = this.state.fieldStep1.admissionDateFm.value;
      fm.matricula = this.state.fieldStep1.matriculaFm.value;
    }
    else if (this.state.objectPlan.publico === 'Pessoa Física')
      fm.TypeFm = 'FISICA';
    else if (this.state.objectPlan.publico === 'Funcionário de Empresa') {
      fm.TypeFm = 'FUNCIONARIO';
      fm.contractNumberS4 = this.state.objectPlan.codeCompany;

      // Para matrícula e data de Admissão
      fm.matricula = this.state.fieldStep1.matriculaFm.value;

      let d = new Date(this.state.fieldStep1.admissionDateFm.value.replace('-', '/').replace('-', '/'));
      let day = d.getDate();
      let month = d.getMonth() + 1;

      if (day < 10)
        day = '0' + day;
      if (month < 10)
        month = '0' + month;

      fm.admissionDate = day+'/'+month+'/'+d.getFullYear();
    }

    return fm;
  }

  preparingDependents() {
    let holder = {
      firstName: "",
      susNumber: "",
      motherName: "",
      cpf: "",
      dateOfBirth: "",
      maritalStatus: "",
      gender: "",
      isHolder: true,
    };
    let dependents = [];
    let deps = this.state.dependent;

    deps.pop();// Remove o último dependente (campos vazio)

    if (this.state.showFormHolder === false) {// O resp financeiro é o titular
      holder.firstName = this.state.fieldStep1.firstNameFm.value;
      holder.susNumber = this.state.fieldStep1.susNumberFm.value;
      holder.motherName = this.state.fieldStep1.motherNameFm.value;
      holder.cpf = this.state.fieldStep1.cpfFm.value;
      holder.dateOfBirth = this.state.fieldStep1.dateOfBirthFm.value;
      holder.maritalStatus = this.state.fieldStep1.maritalStatusFm.value;
      holder.gender = this.state.fieldStep1.genderFm.value;
      holder.plansId = this.state.objectPlan.id;// Plano vindo da escolha de antes do formulário
    }
    else {
      holder.firstName = this.state.fieldStep1.firstNameHol.value;
      holder.susNumber = this.state.fieldStep1.susNumberHol.value;
      holder.motherName = this.state.fieldStep1.motherNameHol.value;
      holder.cpf = this.state.fieldStep1.cpfHol.value;
      holder.dateOfBirth = this.state.fieldStep1.dateOfBirthHol.value;
      holder.maritalStatus = this.state.fieldStep1.maritalStatusHol.value;
      holder.gender = this.state.fieldStep1.genderHol.value;
      holder.plansId = this.state.objectPlan.id;// Plano vindo da escolha de antes do formulário
    }

    // Para planos direto do S4E
    if (this.state.objectPlan.publico === 'Funcionário de Empresa')
      holder.valuePlan = this.state.value_holder;
    else {
      // Para dependentes com planos diferentes do principal
      //if (this.state.differentPlans === true) {
        for (let i = 0; i < this.state.dependentsList.length; i++) {
          if (this.state.dependentsList[i].isHolder === true)
            holder.valuePlan = this.state.dependentsList[i].valuePlan;
        }

        /* holder.valuePlan = this.state.objectPlan.value;
      }
      else
        holder.valuePlan = this.state.valueIndividualPlan; */
    }

    dependents.push(holder);

    // Dependentes da lista
    for (let i = 0; i < deps.length; i++) {
      let dep = {
        firstName: deps[i].firstName.value,
        susNumber: deps[i].susNumber.value,
        motherName: deps[i].motherName.value,
        cpf: deps[i].cpf.value,
        dateOfBirth: deps[i].dateOfBirth.value,
        maritalStatus: deps[i].maritalStatus.value,
        gender: deps[i].gender.value,
        parentage: deps[i].parentage.value,
        isHolder: false,
        //valuePlan: this.state.valueIndividualPlan,
        plansId: deps[i].plansId.value,
      };

      // Para dependentes com planos diferentes do principal
      //if (this.state.differentPlans === true)
        dep.valuePlan = deps[i].valuePlan.value;
      //else
        //dep.valuePlan = this.state.valueIndividualPlan;

      // Para planos direto do S4E
      if (this.state.objectPlan.publico === 'Funcionário de Empresa')
        dep.valuePlan = this.state.value_dependent;

      dependents.push(dep);
    }

    return dependents;
  }

  onSubmitForm() {
    let state = this.state;
    state.finishedLoadingMsg = 'SALVANDO A PROPOSTA...';
    state.finishedLoadingCompleted = 50;
    this.setState(state);

    let dataSubmit = {
      idSalesman: this.state.salesmanId,
      plansId: null,
      financialManagerId: "",
      imagesDocId: "",
      salesFmChanelConfirm: "EMAIL",
      financialManager: this.preparingFm(),
      dependents: this.preparingDependents(),
      imagesDocs: {
        cnh: '',
        cpf: document.getElementById('imagem_cpf').value,
        rg: document.getElementById('imagem_rg').value,
        rg2: document.getElementById('imagem_rg2').value,
        address: document.getElementById('imagem_address').value,
        credtFrontal: document.getElementById('imagem_cardCredit').value,
        physicalContract: document.getElementById('imagem_physicalContract').value,
        others: document.getElementById('imagem_others').value
      }
    };

    // Para planos direto do S4E
    if (this.state.objectPlan.publico === 'Funcionário de Empresa') {
      dataSubmit.financialManager.planCompany = {
        fantasyName: this.state.objectPlan.fantasyName,
        corporateName: this.state.objectPlan.corporateName,
        codeCompany: this.state.objectPlan.codeCompany,
        namePlan: this.state.objectPlan.name,
        codePlan: this.state.objectPlan.id,
      };
    }
    else
      dataSubmit.plansId = this.state.objectPlan.id;

    axios.post(configBase.api + 'FinancialManagers/saveProposal?access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then((response) => {
      let state = this.state;
      state.finishedLoadingMsg = 'ENVIANDO EMAIL AO RESPONSÁVEL FINANCEIRO...';
      state.finishedLoadingCompleted = 80;
      this.setState(state);

      let dataSend = {
        id: response.data.fm
      };

      axios.get(configBase.api + 'FinancialManagers/' + dataSend.id+'?access_token='+localStorage.getItem('planos_t'))
      .then((result) => {

        let state = this.state;
        state.proposalNumber = result.data.proposalNumber;
        this.setState(state);
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar o número da proposta.');
      }.bind(this));

      axios.post(configBase.api + 'Sales/SendEmailProposalCreate?access_token='+localStorage.getItem('planos_t'), dataSend)
      .then(() => {
        let state = this.state;
        state.finishedLoadingMsg = 'PROPOSTA SALVA COM SUCESSO';
        state.finishedLoadingCompleted = 100;
        state.proposalSuccess = true;
        this.setState(state);
      })
      .catch(function () {
        this.setError('Problema encontrado ao enviar email ao Resp. Financeiro');
      }.bind(this));
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar proposta');
    }.bind(this));
  }

  goDashboard() {
    this.finishedModalClose();
    this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
  }

  reloadPage() {
    document.location.reload(true);
  }

  typeDashboardChange(event) {
    let state = this.state;
    state.checkedAtivaTermoAditivo = event.target.checked;
    this.setState(state);
  }

  organizaListaRegistroPlanos(depsComPlanos) {
    if (depsComPlanos.length > 0) {
      let reg = [];
      let resposta = [];

      for (let i = 0; i < depsComPlanos.length; i++) {
        if (reg.indexOf(depsComPlanos[i].registro) < 0) {
          reg.push(depsComPlanos[i].registro);
          resposta.push({
            registro: depsComPlanos[i].registro,
            namePlan: depsComPlanos[i].namePlan,
          });
        }
      }

      return resposta;
    }
    else
      return [];
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setWarning(msg) {
    let state = this.state;
    state.warningRequest = true;
    state.msgWarningRequest = msg;
    this.setState(state);
  }

  warningClose() {
    let state = this.state;
    state.warningRequest = false;
    state.msgWarningRequest = '';
    this.setState(state);
  }



  render() {

    return (
      <MainLayout history={this.props.history}>
        {
          (this.state.showPage === true && this.state.value_total !== undefined && this.state.objectPlan.name !== undefined) ? (

        <div id="formulario">
          {/* Para armazenar hash 64 dos arquivos */}
          <input id="imagem_cpf" type="hidden"/>
          <input id="imagem_rg" type="hidden"/>
          <input id="imagem_rg2" type="hidden"/>
          <input id="imagem_address" type="hidden"/>
          <input id="imagem_cardCredit" type="hidden"/>
          <input id="imagem_physicalContract" type="hidden"/>
          <input id="imagem_others" type="hidden"/>

          <div id="formularioBarra">
            <Paper elevation={0} className="paper">
              <div id="formularioTitulo">
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  INCLUIR PROPOSTA
                </Typography>
              </div>

              <div id="formularioDados">
                <div id="formularioDadosPlano">
                  <div id="formularioDadosPlanoValor">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Total do plano
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      R$ {this.state.value_total}
                    </Typography>
                  </div>

                  {
                    this.state.objectPlan.registro.length > 0 ? (
                  <div id="formularioDadosPlanoNome">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Nome/Registro do plano
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      {this.state.objectPlan.name+"/"+this.state.objectPlan.registro}
                    </Typography>
                  </div>
                    ) : (
                    <div id="formularioDadosPlanoNome">
                      <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                        Nome do Plano/Empresa
                      </Typography>
                      <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                        {this.state.objectPlan.name+"/"+this.state.objectPlan.fantasyName}
                      </Typography>
                    </div>   
                    )
                  }

                  <div id="formularioDadosPlanoDependentes">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Beneficiários
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      {this.state.dependentsList.length}
                    </Typography>
                  </div>
                </div>
              </div>

              <div id="formularioBotoes">
                {
                  this.state.showButtonBack === true ? (
                <div style={{marginRight: 10}}>
                  <Button
                    style={{fontSize: 11, backgroundColor: '#636d77', color: '#fff'}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.backStep.bind(this)}
                    color="default"
                  >
                    VOLTAR
                  </Button>
                </div>
                  ) : ('')
                }

                {
                  this.state.showButtonNext === true ? (
                <div>
                  <Button
                    style={{fontSize: 11, backgroundColor: this.state.colorNextButton, color: configBase.corSecundaria}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.nextStep.bind(this)}
                    color="primary"
                    disabled={this.state.disabledNextButton}
                  >
                    AVANÇAR
                  </Button>
                </div>
                  ) : ('')
                }

                {
                  this.state.showButtonFinished === true ? (
                <div>
                  <Button
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.finishedModalOpen.bind(this)}
                    color="primary"
                  >
                    CONCLUIR
                  </Button>
                </div>
                  ) : ('')
                }

              </div>
            </Paper>
          </div>

          <div id="formularioConteudo">
            <Stepper
              //nonLinear
              activeStep={this.state.stepper}
              style={{background: 'transparent', paddingLeft: 20}}
            >
              <Step>
                <StepLabel className="formularioStepLabel" completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>RESPONSÁVEL FINANCEIRO</div>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel className="formularioStepLabel" completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>BENEFICIÁRIOS</div>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel className="formularioStepLabel" completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>DOCUMENTOS ANEXADOS</div>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel className="formularioStepLabel" completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>RESUMO</div>
                </StepLabel>
              </Step>
            </Stepper>

            {
              this.state.stepper === 0 ? (
            <div className="formularioConteudoPaper">

              <Paper elevation={0} className="paperForm" style={{backgroundColor: configBase.corPrincipal}}>
                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={9} md={9} lg={10}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"
                        style={{
                          color: configBase.corSecundaria,
                          top: 6,
                          position: 'relative',
                          fontSize: 12
                        }}
                      >
                        RETEVE ADESÃO?
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={2}>
                    {
                      this.state.fieldStep1.reteveAdesao.value === false ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOn.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOff.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      ) : (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOn.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,                              
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOff.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      )
                    }
                    </Grid>
                  </Grid>
                </div>
              </Paper>

            {
              this.state.fieldStep1.reteveAdesao.value === true ? (
              <Paper elevation={0} className="paperForm" style={{'backgroundColor': 'orange'}}>
                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={9} md={9} lg={10}>                  
                      <Typography
                      variant="overline" gutterBottom className="titlePaperForm"
                      style={{
                        color: configBase.corSecundaria,                          
                        position: 'relative',
                        fontSize: 12                          
                      }}
                    >
                      <strong>Adesão retida pelo vendedor</strong>
                    </Typography>                                         
                    </Grid>
                  </Grid>
                </div>     
              </Paper>
              ) : ('')
            }

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Habilitar Termo de Aceite do Aditivo de Redução de Carência?
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography component="div">
                        <Grid component="label" container spacing={1}>
                          <Grid style={{fontSize: 16, lineHeight: '35px'}} item>Não</Grid>
                          <Grid item style={{padding: '4px 0px'}}>
                            <Switch
                              checked={this.state.checkedAtivaTermoAditivo}
                              onChange={this.typeDashboardChange.bind(this)}
                            />
                          </Grid>
                          <Grid style={{fontSize: 16, lineHeight: '35px'}} item>Sim</Grid>
                        </Grid>
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Dados Pessoais
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={7} lg={7}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.firstNameFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.firstNameFm.error}
                        label={this.state.fieldStep1.firstNameFm.required === true ? ("Nome Completo *"):("Nome Completo")}
                        type={this.state.fieldStep1.firstNameFm.type}
                        variant="outlined"
                        size="small"
                        name="firstNameFm"
                        value={this.state.fieldStep1.firstNameFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=" "
                        disabled={this.state.fieldStep1.cpfFm.loading}
                        value={this.state.fieldStep1.cpfFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.countFinancialManager.bind(this)}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cpfFm.required === true ? ("CPF *"):("CPF")}
                          variant="outlined"
                          size="small"
                          name="cpfFm"
                          //type={this.state.fieldStep1.cpfFm.type}
                          error={this.state.fieldStep1.cpfFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cpfFm.error}
                          disabled={this.state.fieldStep1.cpfFm.loading}
                        />}
                      </InputMask>
                      {
                        this.state.fieldStep1.cpfFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.emailFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.emailFm.error}
                        label={this.state.fieldStep1.emailFm.required === true ? ("E-mail *"):("E-mail")}
                        type={this.state.fieldStep1.emailFm.type}
                        variant="outlined"
                        size="small"
                        name="emailFm"
                        value={this.state.fieldStep1.emailFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.emailFm.loading}
                        onBlur={this.countFinancialManagerEmail.bind(this)}
                      />

                      {
                        this.state.fieldStep1.emailFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <InputMask
                        mask="(99) 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.homePhoneFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateTel.bind(this, 'homePhoneFm')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.homePhoneFm.required === true ? ("Tel. Fixo *"):("Tel. Fixo")}
                          error={this.state.fieldStep1.homePhoneFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.homePhoneFm.error}
                          //type={this.state.fieldStep1.homePhoneFm.type}
                          variant="outlined"
                          size="small"
                          name="homePhoneFm"
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.cellPhoneFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateCell.bind(this, 'cellPhoneFm')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cellPhoneFm.required === true ? ("Celular *"):("Celular")}
                          error={this.state.fieldStep1.cellPhoneFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cellPhoneFm.error}
                          variant="outlined"
                          //type={this.state.fieldStep1.cellPhoneFm.type}
                          size="small"
                          name="cellPhoneFm"
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.cellPhone2Fm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateCell.bind(this, 'cellPhone2Fm')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cellPhone2Fm.required === true ? ("2º Celular *"):("2º Celular")}
                          error={this.state.fieldStep1.cellPhone2Fm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cellPhone2Fm.error}
                          variant="outlined"
                          //type={this.state.fieldStep1.cellPhone2Fm.type}
                          size="small"
                          name="cellPhone2Fm"
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.rgFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.rgFm.error}
                        label={this.state.fieldStep1.rgFm.required === true ? ("RG *"):("RG")}
                        type="tel"
                        variant="outlined"
                        size="small"
                        name="rgFm"
                        value={this.state.fieldStep1.rgFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.rgEmitterFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.rgEmitterFm.error}
                        label={this.state.fieldStep1.rgEmitterFm.required === true ? ("Org. Emissor *"):("Org. Emissor")}
                        type={this.state.fieldStep1.rgEmitterFm.type}
                        variant="outlined"
                        size="small"
                        name="rgEmitterFm"
                        value={this.state.fieldStep1.rgEmitterFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                        <KeyboardDatePicker
                          autoOk
                          fullWidth
                          error={this.state.fieldStep1.dateOfBirthFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.dateOfBirthFm.error}
                          variant="inline"
                          inputVariant="outlined"
                          label={this.state.fieldStep1.dateOfBirthFm.required === true ? ("Data de Nascimento *"):("Data de Nascimento")}
                          format="dd/MM/yyyy"
                          size="small"
                          name="dateOfBirthFm"
                          value={
                            this.state.fieldStep1.dateOfBirthFm.value === null ? (null) : (
                              this.state.fieldStep1.dateOfBirthFm.value+'T00:00:00'
                            )
                          }
                          onChange={this.updateFieldDate.bind(this, 'fieldStep1', 'dateOfBirthFm')}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.motherNameFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.motherNameFm.error}
                        label={this.state.fieldStep1.motherNameFm.required === true ? ("Mãe *"):("Mãe")}
                        type={this.state.fieldStep1.motherNameFm.type}
                        variant="outlined"
                        size="small"
                        name="motherNameFm"
                        value={this.state.fieldStep1.motherNameFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.maritalStatusFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.maritalStatusFm.error}
                        label={this.state.fieldStep1.maritalStatusFm.required === true ? ("Estado Civil *"):("Estado Civil")}
                        variant="outlined"
                        size="small"
                        name="maritalStatusFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.maritalStatusFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="SOLTEIRO">Solteiro</option>
                        <option value="CASADO">Casado</option>
                        <option value="VIÚVO">Viúvo</option>
                        <option value="SEPARADO">Separado</option>
                        <option value="DIVORCIADO">Divorciado</option>
                        <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                      </TextField>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.genderFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.genderFm.error}
                        label={this.state.fieldStep1.genderFm.required === true ? ("Sexo *"):("Sexo")}
                        variant="outlined"
                        size="small"
                        name="genderFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.genderFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="0">Feminino</option>
                        <option value="1">Masculino</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.susNumberFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.susNumberFm.error}
                        label={this.state.fieldStep1.susNumberFm.required === true ? ("Cartão do SUS *"):("Cartão do SUS")}
                        type="tel"
                        variant="outlined"
                        size="small"
                        name="susNumberFm"
                        value={this.state.fieldStep1.susNumberFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateSus.bind(this, 'fieldStep1', 'susNumberFm')}
                      />
                    </Grid>
                    {
                      this.state.showMatricula === true ? (
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.matriculaFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.matriculaFm.error}
                        label={this.state.fieldStep1.matriculaFm.required === true ? ("Matrícula *"):("Matrícula")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="matriculaFm"
                        value={this.state.fieldStep1.matriculaFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                      ) : ('')
                    }

                    {
                      this.state.showAdmissionDateFm === true ? (
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                        <KeyboardDatePicker
                          autoOk
                          fullWidth
                          error={this.state.fieldStep1.admissionDateFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.admissionDateFm.error}
                          variant="inline"
                          inputVariant="outlined"
                          label={this.state.fieldStep1.admissionDateFm.required === true ? ("Data de Admissão *"):("Data de Admissão")}
                          format="dd/MM/yyyy"
                          size="small"
                          name="admissionDateFm"
                          value={
                            this.state.fieldStep1.admissionDateFm.value === null ? (null) : (
                              this.state.fieldStep1.admissionDateFm.value+'T00:00:00'
                            )
                          }
                          onChange={this.updateFieldDate.bind(this, 'fieldStep1', 'admissionDateFm')}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                      ) : ('')
                    }
                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Endereço
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <InputMask
                        mask="99.999-999"
                        maskChar=" "
                        value={this.state.fieldStep1.cepFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        //onBlur={this.getAddress.bind(this)}
                      >
                        {() => <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="cepFm"
                          error={this.state.fieldStep1.cepFm.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cepFm.error}
                          label={this.state.fieldStep1.cepFm.required === true ? ("CEP *"):("CEP")}
                          //type={this.state.fieldStep1.cepFm.type}
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.addressTypeFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressTypeFm.error}
                        label={this.state.fieldStep1.addressTypeFm.required === true ? ("Logradouro *"):("Logradouro")}
                        variant="outlined"
                        size="small"
                        name="addressTypeFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.addressTypeFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.addressTypeFm.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.addressTypeList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.addressTypeFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.addressFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressFm.error}
                        label={this.state.fieldStep1.addressFm.required === true ? ("Endereço *"):("Endereço")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="addressFm"
                        value={this.state.fieldStep1.addressFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.addressFm.loading}
                      />

                      {
                        this.state.fieldStep1.addressFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <TextField
                        id="i_addressNumberFm"
                        fullWidth
                        error={this.state.fieldStep1.addressNumberFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressNumberFm.error}
                        label={this.state.fieldStep1.addressNumberFm.required === true ? ("Nº *"):("Nº")}
                        type="tell"
                        variant="outlined"
                        size="small"
                        name="addressNumberFm"
                        value={this.state.fieldStep1.addressNumberFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={1} lg={1} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.stateFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.stateFm.error}
                        label={this.state.fieldStep1.stateFm.required === true ? ("UF *"):("UF")}
                        variant="outlined"
                        size="small"
                        name="stateFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.stateFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.stateFm.loading}
                      >
                        <option value="null">UF</option>
                      {this.state.stateList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Sigla}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.stateFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.addressComplementFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressComplementFm.error}
                        label={this.state.fieldStep1.addressComplementFm.required === true ? ("Complemento *"):("Complemento")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="addressComplementFm"
                        value={this.state.fieldStep1.addressComplementFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.cityFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.cityFm.error}
                        label={this.state.fieldStep1.cityFm.required === true ? ("Município *"):("Município")}
                        variant="outlined"
                        size="small"
                        name="cityFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.cityFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.cityFm.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.cityList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.cityFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.districtFm.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.districtFm.error}
                        label={this.state.fieldStep1.districtFm.required === true ? ("Bairro *"):("Bairro")}
                        variant="outlined"
                        size="small"
                        name="districtFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.districtFm.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.districtFm.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.districtList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.districtFm.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                  </Grid>
                </div>
              </Paper>

              {
                this.state.objectPlan.publico !== 'Funcionário de Empresa' ? (
              <Paper elevation={0} className="paperForm" style={{backgroundColor: configBase.corPrincipal}}>
                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={9} md={9} lg={10}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"
                        style={{
                          color: configBase.corSecundaria,
                          top: 6,
                          position: 'relative',
                          fontSize: 12
                        }}
                      >
                        O RESPONSÁVEL FINANCEIRO SERÁ TITULAR DO PLANO?
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={2}>
                    {
                      this.state.showFormHolder === false ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.showFormHolderOff.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.showFormHolderOn.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      ) : (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.showFormHolderOff.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.showFormHolderOn.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      )
                    }
                    </Grid>
                  </Grid>
                </div>
              </Paper>
                ) : ('')
              }

              {
                this.state.showFormHolder === true ? (
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Titular
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={7} lg={7}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.firstNameHol.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.firstNameHol.error}
                        label={this.state.fieldStep1.firstNameHol.required === true ? ("Nome Completo *"):("Nome Completo")}
                        type={this.state.fieldStep1.firstNameHol.type}
                        variant="outlined"
                        size="small"
                        name="firstNameHol"
                        value={this.state.fieldStep1.firstNameHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=" "
                        disabled={this.state.fieldStep1.cpfHol.loading}
                        value={this.state.fieldStep1.cpfHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateAllCpf.bind(this, 'fieldStep1', 'cpfHol')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cpfHol.required === true ? ("CPF *"):("CPF")}
                          variant="outlined"
                          size="small"
                          name="cpfHol"
                          error={this.state.fieldStep1.cpfHol.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cpfHol.error}
                          //type={this.state.fieldStep1.cpfHol.type}
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                        <KeyboardDatePicker
                          autoOk
                          fullWidth
                          error={this.state.fieldStep1.dateOfBirthHol.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.dateOfBirthHol.error}
                          variant="inline"
                          inputVariant="outlined"
                          label={this.state.fieldStep1.dateOfBirthHol.required === true ? ("Data de Nascimento *"):("Data de Nascimento")}
                          format="dd/MM/yyyy"
                          size="small"
                          name="dateOfBirthHol"
                          value={
                            this.state.fieldStep1.dateOfBirthHol.value === null ? (null) : (
                              this.state.fieldStep1.dateOfBirthHol.value+'T00:00:00'
                            )
                          }
                          onChange={this.updateFieldDate.bind(this, 'fieldStep1', 'dateOfBirthHol')}
                          onBlur={this.validateAgeCpfHolder.bind(this)}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.maritalStatusHol.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.maritalStatusHol.error}
                        label={this.state.fieldStep1.maritalStatusHol.required === true ? ("Estado Civil *"):("Estado Civil")}
                        variant="outlined"
                        size="small"
                        name="maritalStatusHol"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.maritalStatusHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="SOLTEIRO">Solteiro</option>
                        <option value="CASADO">Casado</option>
                        <option value="VIÚVO">Viúvo</option>
                        <option value="SEPARADO">Separado</option>
                        <option value="DIVORCIADO">Divorciado</option>
                        <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.genderHol.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.genderHol.error}
                        label={this.state.fieldStep1.genderHol.required === true ? ("Sexo *"):("Sexo")}
                        variant="outlined"
                        size="small"
                        name="genderHol"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.genderHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="0">Feminino</option>
                        <option value="1">Masculino</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.motherNameHol.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.motherNameHol.error}
                        label={this.state.fieldStep1.motherNameHol.required === true ? ("Mãe *"):("Mãe")}
                        type={this.state.fieldStep1.motherNameHol.type}
                        variant="outlined"
                        size="small"
                        name="motherNameHol"
                        value={this.state.fieldStep1.motherNameHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.susNumberHol.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.susNumberHol.error}
                        label={this.state.fieldStep1.susNumberHol.required === true ? ("Cartão do SUS *"):("Cartão do SUS")}
                        type="tel"
                        variant="outlined"
                        size="small"
                        name="susNumberHol"
                        value={this.state.fieldStep1.susNumberHol.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateSus.bind(this, 'fieldStep1', 'susNumberHol')}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Paper>
                ) : ('')
              }

            </div>
              ) : (
                this.state.stepper === 1 ? (
            <div className="formularioConteudoPaper">
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Adicionar beneficiários
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <TextField
                        id="i_dep_parentage"
                        fullWidth
                        select
                        error={this.state.dependent[this.state.depIndex].parentage.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].parentage.error}
                        label="Parentesco"
                        variant="outlined"
                        size="small"
                        name="parentage"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.dependent[this.state.depIndex].parentage.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="CÔNJUGE">Cônjuge</option>
                        <option value="FILHO">Filho</option>
                        <option value="PAI/MÃE">Pai/Mãe</option>
                        <option value="ENTEADO">Enteado</option>
                        <option value="OUTRO">Outro</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} lg={5}>
                      <TextField
                        fullWidth
                        error={this.state.dependent[this.state.depIndex].firstName.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].firstName.error}
                        label="Nome Completo"
                        type={this.state.dependent[this.state.depIndex].firstName.type}
                        variant="outlined"
                        size="small"
                        name="firstName"
                        value={this.state.dependent[this.state.depIndex].firstName.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=" "
                        disabled={this.state.dependent[this.state.depIndex].cpf.loading}
                        value={this.state.dependent[this.state.depIndex].cpf.value}
                        onChange={this.updateFieldDependents.bind(this)}
                        onBlur={this.validateAllCpf.bind(this, 'dependent', 'cpf')}
                      >
                        {() => <TextField
                          fullWidth
                          label="CPF"
                          variant="outlined"
                          size="small"
                          name="cpf"
                          error={this.state.dependent[this.state.depIndex].cpf.error.length > 0 ? (true):(false)}
                          helperText={this.state.dependent[this.state.depIndex].cpf.error}
                          disabled={this.state.dependent[this.state.depIndex].cpf.loading}
                        />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                        <KeyboardDatePicker
                          autoOk
                          fullWidth
                          error={this.state.dependent[this.state.depIndex].dateOfBirth.error.length > 0 ? (true):(false)}
                          helperText={this.state.dependent[this.state.depIndex].dateOfBirth.error}
                          variant="inline"
                          inputVariant="outlined"
                          label="Data de Nascimento"
                          format="dd/MM/yyyy"
                          size="small"
                          name="dateOfBirth"
                          value={
                            this.state.dependent[this.state.depIndex].dateOfBirth.value === null ? (null) : (
                              this.state.dependent[this.state.depIndex].dateOfBirth.value+'T00:00:00'
                            )
                          }
                          onChange={this.updateFieldDate.bind(this, 'dependent', 'dateOfBirth')}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.dependent[this.state.depIndex].maritalStatus.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].maritalStatus.error}
                        label="Estado Civil"
                        variant="outlined"
                        size="small"
                        name="maritalStatus"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.dependent[this.state.depIndex].maritalStatus.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="SOLTEIRO">Solteiro</option>
                        <option value="CASADO">Casado</option>
                        <option value="VIÚVO">Viúvo</option>
                        <option value="SEPARADO">Separado</option>
                        <option value="DIVORCIADO">Divorciado</option>
                        <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.dependent[this.state.depIndex].gender.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].gender.error}
                        label="Sexo"
                        variant="outlined"
                        size="small"
                        name="gender"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.dependent[this.state.depIndex].gender.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        <option value="0">Feminino</option>
                        <option value="1">Masculino</option>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <TextField
                        fullWidth
                        error={this.state.dependent[this.state.depIndex].motherName.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].motherName.error}
                        label="Mãe"
                        type={this.state.dependent[this.state.depIndex].motherName.type}
                        variant="outlined"
                        size="small"
                        name="motherName"
                        value={this.state.dependent[this.state.depIndex].motherName.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <TextField
                        fullWidth
                        error={this.state.dependent[this.state.depIndex].susNumber.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].susNumber.error}
                        label="Cartão do SUS"
                        type="tel"
                        variant="outlined"
                        size="small"
                        name="susNumber"
                        value={this.state.dependent[this.state.depIndex].susNumber.value}
                        onChange={this.updateFieldDependents.bind(this)}
                        onBlur={this.validateSus.bind(this, 'dependent', 'susNumber')}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.dependent[this.state.depIndex].plansId.error.length > 0 ? (true):(false)}
                        helperText={this.state.dependent[this.state.depIndex].plansId.error}
                        label="Plano"
                        variant="outlined"
                        size="small"
                        name="plansId"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.dependent[this.state.depIndex].plansId.value}
                        onChange={this.updateFieldDependents.bind(this)}
                      >
                        <option value="null">Selecione</option>
                        {this.state.plansList.map((item, index) =>
                          <option key={index} value={item.value}>{item.label}</option>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </div>
              </Paper>

              <Button
                style={{fontSize: 11, backgroundColor: configBase.corPrincipal, width: 250, margin: '10px 0 20px 0'}}
                variant="contained"
                size="small"
                onClick={this.checkFormDependent.bind(this)}
                color="primary"
              >
                ADICIONAR BENEFICIÁRIO
              </Button>

              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              <div>
                <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                  <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                    <tr style={this.styles.theadTr}>
                      <th style={this.styles.theadTh}>
                        <Typography variant="button" display="block" gutterBottom
                          style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                        >
                          TIPO
                        </Typography>
                      </th>
                      <th style={this.styles.theadTh}>
                        <Typography variant="button" display="block" gutterBottom
                          style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                          >
                          NOME
                        </Typography>
                      </th>
                      <th style={this.styles.theadTh}>
                        <Typography variant="button" display="block" gutterBottom
                          style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                          >
                          PLANO
                        </Typography>
                      </th>
                      <th style={this.styles.theadTh}>
                        <Typography variant="button" display="block" gutterBottom
                          style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                        >
                          VALOR UNITÁRIO
                        </Typography>
                      </th>
                      <th style={this.styles.theadTh}>
                        <Typography variant="button" display="block" gutterBottom
                          style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                        >
                          AÇÕES
                        </Typography>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.dependentsList.map((item, index) =>
                    <tr
                      key={index}
                      className="row_table"
                      style={this.styles.theadTh}
                    >
                      <td style={{padding: 0, height: 40}}>
                        <Typography variant="overline" display="block" gutterBottom
                          style={{color: '#757575', margin: 0, fontSize: 11}}
                        >
                          {
                            item.isHolder === true ? (
                        <span
                          style={{
                            padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                            borderRadius: 5, color: configBase.corPrincipal}}
                        >
                          TITULAR
                        </span>
                            ) : (
                        <span
                          style={{
                            padding: '5px 7px', border: '1px solid #757575',
                            borderRadius: 5, color: '#757575'}}
                        >
                          DEPENDENTE
                        </span>
                            )
                          }
                        </Typography>
                      </td>
                      <td style={{padding: 0, height: 40}}>
                        <Typography variant="overline" display="block" gutterBottom
                          style={{color: '#757575', margin: 0, fontSize: 11}}
                        >
                          {item.firstName}
                        </Typography>
                      </td>
                      <td style={{padding: 0, height: 40}}>
                        <Typography variant="overline" display="block" gutterBottom
                          style={{color: '#757575', margin: 0, fontSize: 11}}
                        >
                          {item.namePlan}
                        </Typography>
                      </td>
                      <td style={{padding: 0, height: 40}}>
                        <Typography variant="overline" display="block" gutterBottom
                          style={{color: '#757575', margin: 0, fontSize: 11}}
                        >
                          {
                          this.state.objectPlan.publico === 'Funcionário de Empresa' ? (
                            item.isHolder === false ? (
                              'R$ '+parseFloat(this.state.value_dependent.replace(',','.')).toFixed(2).replace('.',',')
                            ) : (
                              'R$ '+parseFloat(this.state.value_holder.replace(',','.')).toFixed(2).replace('.',',')
                            )
                          ) : (
                            'R$ '+item.valuePlan
                          )
                        }
                        </Typography>
                      </td>
                      <td style={{padding: 0, height: 40}}>
                      {
                        item.isHolder === false ? (
                        <div>
                          <IconButton
                            aria-label="delete"
                            style={{padding: '8px 8px'}}
                            onClick={this.deleteDependentList.bind(this, index)}
                          >
                            <DeleteIcon />
                          </IconButton>

                          <IconButton
                            aria-label="delete"
                            style={{padding: '8px 8px'}}
                            onClick={this.editDependentList.bind(this, index)}
                          >
                            <EditIcon />
                          </IconButton>
                        </div>
                        ) : (<div></div>)
                      }
                      </td>
                    </tr>
                  )}

                  </tbody>
                </table>
              </div>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="myLengthMenu">Linhas por página: </label>
                  <select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    {/* <option value="-1">Todas</option> */}
                  </select>
                  <span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
                  {' '}de{' '}
                  <span id="tablePageTotal"></span>
                </div>
              </div>

              <Dialog
                fullScreen={this.state.fullScreenModal}
                open={this.state.modalNoDependents}
                onClose={this.modalNoDependentsClose.bind(this)}
                aria-labelledby="i_modalConfirm"
              >
                <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Prosseguir sem adicionar dependentes?
                  </DialogContentText>
                </DialogContent>

                <DialogActions>
                  <Button autoFocus color="primary"
                    onClick={this.modalNoDependentsClose.bind(this)}
                  >
                    NÃO
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.goStep3.bind(this)}
                  >
                    SIM
                  </Button>
                </DialogActions>
              </Dialog>

            </div>
                ) : (
                  this.state.stepper === 2 ? (
            <div className="formularioConteudoPaper">
              <Paper elevation={0} className="paperForm" style={{backgroundColor: configBase.corPrincipal}}>
                <div className="paper">
                  <InfoOutlinedIcon style ={{color: configBase.corSecundaria, top: 2, position: 'relative'}}/>
                  <Typography
                    variant="overline" gutterBottom
                    style={{
                      color: configBase.corSecundaria,
                      textTransform: 'none',
                      fontSize: 13,
                      position: 'relative',
                      bottom: 5,
                      marginLeft: 10,
                    }}
                  >
                    Anexar cópias dos documentos do responsável financeiro
                  </Typography>
                </div>
              </Paper>

              <div className="paper">
                <Grid container spacing={2}>
                  {/* ################### Imagem RG Frente ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="RG FRENTE"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                      >
                        {
                          this.state.imagesDocsUrl.rg.url.length > 0 ? (
                            this.state.imagesDocsUrl.rg.url.substr(this.state.imagesDocsUrl.rg.url.length - 3, this.state.imagesDocsUrl.rg.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="RG FRENTE"
                          height="140"
                          image={this.state.imagesDocsUrl.rg.url}
                          title="RG FRENTE"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.rg.error.length > 0 ? (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                            {this.state.imagesDocsUrl.rg.error}
                          </Alert>
                        </div>
                            ) : (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <MuiAlert severity="info" variant="filled" elevation={0}
                            style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                          >
                            Nenhum arquivo anexado
                          </MuiAlert>
                        </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.rg.url.length > 0 ? (
                      <CardActions>
                        {/* <Button
                          size="small"
                          color="primary"
                          //onClick={this.openWindow.bind(this, this.state.imagesDocsUrl.rg.url, 'Arquivo do RG')}
                        >
                          Visualizar
                        </Button> */}
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem RG Verso ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="RG VERSO"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                      >
                        {
                          this.state.imagesDocsUrl.rg2.url.length > 0 ? (
                            this.state.imagesDocsUrl.rg2.url.substr(this.state.imagesDocsUrl.rg2.url.length - 3, this.state.imagesDocsUrl.rg2.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="RG VERSO"
                          height="140"
                          image={this.state.imagesDocsUrl.rg2.url}
                          title="RG VERSO"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.rg2.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.rg2.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.rg2.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem CPF ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="CPF"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                      >
                        {
                          this.state.imagesDocsUrl.cpf.url.length > 0 ? (
                            this.state.imagesDocsUrl.cpf.url.substr(this.state.imagesDocsUrl.cpf.url.length - 3, this.state.imagesDocsUrl.cpf.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="CPF"
                          height="140"
                          image={this.state.imagesDocsUrl.cpf.url}
                          title="CPF"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.cpf.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.cpf.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.cpf.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem COMPROVANTE DE RESIDÊNCIA ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="COMPROVANTE DE RESIDÊNCIA"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                      >
                        {
                          this.state.imagesDocsUrl.address.url.length > 0 ? (
                            this.state.imagesDocsUrl.address.url.substr(this.state.imagesDocsUrl.address.url.length - 3, this.state.imagesDocsUrl.address.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="COMPROVANTE DE RESIDÊNCIA"
                          height="140"
                          image={this.state.imagesDocsUrl.address.url}
                          title="COMPROVANTE DE RESIDÊNCIA"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.address.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.address.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.address.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem CARTÃO DE CRÉDITO ################### */}
                  {/* <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="CARTÃO DE CRÉDITO"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'cardCredit')}
                      >
                        {
                          this.state.imagesDocsUrl.cardCredit.url.length > 0 ? (
                            this.state.imagesDocsUrl.cardCredit.url.substr(this.state.imagesDocsUrl.cardCredit.url.length - 3, this.state.imagesDocsUrl.cardCredit.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="CARTÃO DE CRÉDITO"
                          height="140"
                          image={this.state.imagesDocsUrl.cardCredit.url}
                          title="CARTÃO DE CRÉDITO"
                        />
                            )
                          ) : (
                          this.state.imagesDocsUrl.cardCredit.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.cardCredit.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.cardCredit.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cardCredit')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cardCredit')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid> */}
                  {/* ################### Imagem OUTROS ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="OUTROS"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                      >
                        {
                          this.state.imagesDocsUrl.others.url.length > 0 ? (
                            this.state.imagesDocsUrl.others.url.substr(this.state.imagesDocsUrl.others.url.length - 3, this.state.imagesDocsUrl.others.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="OUTROS"
                          height="140"
                          image={this.state.imagesDocsUrl.others.url}
                          title="OUTROS"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.others.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.others.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.others.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                </Grid>
              </div>

              <DropzoneDialog
                dialogTitle="Upload do arquivo"
                cancelButtonText="CANCELAR"
                submitButtonText="OK"
                getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
                open={this.state.dropzoneDialog}
                onSave={this.fileToBase64.bind(this)}
                acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={this.dropzoneDialogClose.bind(this)}
                filesLimit={1}
                dropzoneText="Clique ou arraste e solte um arquivo aqui"
                previewText="Pré-visualização"
                showAlerts={false}
              />
            </div>
                  ) : (
                    this.state.stepper === 3 ? (
            <div id="contentPrint" className="formularioConteudoPaper">
              <div ref={el => (this.printContent = el)}>
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <Typography variant="h6" gutterBottom className="titlePaperForm">
                      Resumo
                    </Typography>
                  </div>

                  <div>
                    <Divider />
                  </div>

                  <div className="paper">
                    <Paper elevation={0} className="paperForm paper_resume">
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          RESPONSÁVEL FINANCEIRO
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Nome:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.firstNameFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              CPF:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cpfFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              E-mail:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.emailFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Tel. Fixo:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.homePhoneFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Celular:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cellPhoneFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              RG:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.rgFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Org. Emissor:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.rgEmitterFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Data de Nascimento:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.dateOfBirthFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Mãe:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.motherNameFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Estado Civil:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.maritalStatusFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Sexo:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>
                              {
                                this.state.fieldStep1.genderFm.value === '0' ? ("Feminino") : ("Masculino")
                              }
                              </strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Cartão do SUS:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.susNumberFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              CEP:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cepFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Logradouro:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.addressTypeToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Endereço:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.addressFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Nº:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.addressNumberFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={2} lg={1}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              UF:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.stateToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Complemento:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.addressComplementFm.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Município:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.cityToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Bairro:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.districtToResume()}</strong>
                            </Typography>
                          </Grid>

                        </Grid>
                      </div>
                    </Paper>

                    <Paper elevation={0} className="paperForm paper_resume" style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          BENEFICIÁRIOS
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>

                        {this.state.dependentsList.map((item, index) =>
                          <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={2} md={2} lg={2}>
                                <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                                  Tipo:
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>
                                    {
                                      item.isHolder === true ? ('TITULAR') : ('DEPENDENTE')
                                    }
                                  </strong>
                                </Typography>
                              </Grid>

                              <Grid item xs={12} sm={4} md={4} lg={4}>
                                <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                                  Nome:
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>{item.firstName}</strong>
                                </Typography>
                              </Grid>

                              <Grid item xs={12} sm={4} md={4} lg={4}>
                                <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                                  Plano:
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>{item.namePlan}</strong>
                                </Typography>
                              </Grid>

                              <Grid item xs={12} sm={2} md={2} lg={2}>
                                <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                                  Valor:
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  R$ <strong>{item.valuePlan.replace('.', ',')}</strong>
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        </Grid>
                      </div>
                    </Paper>

                    {
                      !this.state.objectPlan.registro && (
                    <Paper elevation={0} className="paperForm paper_resume"  style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          INFORMAÇÕES DO PLANO
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={3} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Empresa:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.objectPlan.fantasyName}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={5} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Plano:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.objectPlan.name}</strong>
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    </Paper>
                      )
                    }

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={7} md={6} lg={4}>
                        <Paper elevation={0} className="paperForm paper_resume">
                          <div className="paper">
                            <Typography
                              variant="overline" gutterBottom className="titlePaperForm"
                              style={{fontWeight: 'normal'}}
                            >
                              VALOR TOTAL
                            </Typography>
                          </div>

                          <div style={{padding: '0 20px'}}>
                          {
                              this.state.objectPlan.publico === 'Funcionário de Empresa' ? (
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>TITULAR</strong>
                                </Typography>
                              </Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}></Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'right'}}
                                >
                                  <strong>R$ {this.state.value_holder}</strong>
                                </Typography>
                              </Grid>

                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>{this.state.dependentsList.length - 1} DEPENDENTE(S)</strong>
                                </Typography>
                              </Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}></Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'right'}}
                                >
                                  <strong>R$ {
                                  ((this.state.dependentsList.length - 1)*parseFloat(this.state.value_dependent.replace(',','.'))).toFixed(2).replace('.', ',')
                                  }</strong>
                                </Typography>
                              </Grid>
                            </Grid>
                              ) : (
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                {
                                  this.state.differentPlans === true ? (
                                  <strong>PLANO DENTAL</strong>
                                    ) : (
                                  <strong>{this.state.dependentsList.length}X PLANO DENTAL</strong>
                                    )
                                }
                                </Typography>
                              </Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}></Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'right'}}
                                >
                                  <strong>R$ {this.state.value_total}</strong>
                                </Typography>
                              </Grid>
                            </Grid>
                              )
                            }

                            <div>
                              <Divider style={{marginBottom: 10, backgroundColor: '#bbb'}} />
                            </div>

                            <Grid container spacing={2}>
                              <Grid item xs={8} sm={8} md={8} lg={8}>
                                <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                                  <strong>TAXA DE IMPLEMENTAÇÃO</strong>
                                </Typography>
                              </Grid>
                              <Grid item xs={1} sm={1} md={1} lg={1}></Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'right'}}
                                >
                                  <strong>R$ {this.state.implantationRate}</strong>
                                </Typography>
                              </Grid>
                            </Grid>

                            <div>
                              <Divider style={{marginBottom: 10, backgroundColor: '#bbb'}} />
                            </div>

                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6} lg={6}></Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'center'}}
                                >
                                  <strong>TOTAL</strong>
                                </Typography>
                              </Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3}>
                                <Typography
                                  variant="overline" display="block" gutterBottom
                                  style={{color: '#333', textAlign: 'right'}}
                                >
                                  <strong>R$ {this.state.value_total}</strong>
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                        </Paper>
                      </Grid>
                    </Grid>
                  </div>
                </Paper>
              </div>

              {/* Página de Impressão */}

              {                
                this.state.imprimir === true && (
              <div id="printOnly" ref={el => (this.printContentFinal = el)} style={{display: "none"}}>
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <div>
                      <img id="imagemId" alt="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                    </div>

                    <div>
                      <Typography style={{textAlign: 'center', color: configBase.corPrincipal}} variant="h6" gutterBottom className="titlePaperForm">
                        RESUMO DA PROPOSTA Nº {this.state.proposalNumber}
                      </Typography>
                    </div>
                  </div>

                  <div>
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography variant="overline" gutterBottom className="titlePaperForm">
                        RESPONSÁVEL FINANCEIRO
                      </Typography>
                    </div>

                    <div className="formPrintFields">
                      <Grid container spacing={2} className="respFinanceiro">                                                        
                        <div className="page-break" />                              
                        <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nome:</strong>
                          </Typography>

                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.firstNameFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CPF:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.cpfFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>E-mail:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.emailFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Tel. Fixo:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.homePhoneFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Celular:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.cellPhoneFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>RG:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.rgFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Org. Emissor:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.rgEmitterFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Data de Nascimento:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.dateOfBirthFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Mãe:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.motherNameFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Estado Civil:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.maritalStatusFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Sexo:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.genderFm.value === '0' ? ("Feminino") : ("Masculino")}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Cartão do SUS:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.susNumberFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CEP:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.cepFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Logradouro:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.addressTypeToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Endereço:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.addressFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nº:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.addressNumberFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={2} lg={1} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>UF:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.stateToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Complemento:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.fieldStep1.addressComplementFm.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Município:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.cityToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Bairro:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {this.districtToResume()}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography variant="overline" gutterBottom className="titlePaperForm">
                        Beneficiários
                      </Typography>
                    </div>

                    <div className="formPrintFields">
                    {this.state.dependentsList.map((item, index) =>
                      <Grid key={index} container spacing={2} className="beneficiarios">
                        <div className="page-break" />
                        <Grid item xs={2} className="atribBeneficiarios">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Tipo:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {item.isHolder === true ? ('TITULAR') : ('DEPENDENTE')}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} className="atribBeneficiarios">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nome:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {item.firstName}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} className="atribBeneficiarios">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Plano:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            {item.namePlan}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} className="atribBeneficiarios">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Valor:</strong>
                          </Typography>

                          <Typography variant="overline" display="block" gutterBottom>
                            R$ {item.valuePlan.replace('.', ',')}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography variant="overline" gutterBottom className="titlePaperForm">
                        Informações do(s) Plano(s)
                      </Typography>
                    </div>

                    <div className="formPrintFields">
                      <Grid container spacing={2} className="infoPlano">
                      {this.organizaListaRegistroPlanos(this.state.dependentsList).map((item, index) =>
                        <div key={index} style={{display: 'contents'}}>
                          <div className="page-break" />
                          <Grid item xs={2} sm={2} md={2} lg={2} className="atribInfoPlano">
                            <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                              <strong>Registro:</strong>
                            </Typography>

                            <Typography variant="overline" display="block" gutterBottom>
                              {item.registro}
                            </Typography>
                          </Grid>

                          <div className="page-break" />
                          <Grid item xs={4} sm={4} md={4} lg={4} className="atribInfoPlano">
                            <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                              <strong>Plano:</strong>
                            </Typography>

                            <Typography variant="overline" display="block" gutterBottom>
                              {item.namePlan}
                            </Typography>
                          </Grid>
                        </div>
                      )}
                      </Grid>
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography variant="overline" gutterBottom className="titlePaperForm">
                        Valor Total
                      </Typography>
                    </div>

                    <div className="formPrintFields">
                      <Grid container spacing={2} className="valorTotal">
                        <div className="page-break" />
                        <Grid item xs={3} sm={6} md={6} lg={3} className="atribValorTotal">                     
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>{this.state.dependentsList.length}X PLANO DENTAL</strong>
                          </Typography>   
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal">
                          <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>
                            R$ {this.state.value_total}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={3} sm={6} md={3} lg={3} className="atribValorTotal">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>TAXA DE IMPLEMENTAÇÃO</strong>
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal">
                          <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>
                            R$ {this.state.implantationRate}
                          </Typography>
                        </Grid>                                             

                        <div className="page-break" />
                        <Grid item xs={3} sm={6} md={6} lg={3} className="atribValorTotal">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>TOTAL</strong>
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal">
                          <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>                                                 
                          R$ {this.state.value_total}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Paper>
              </div>
                )
              }



              <Dialog
                fullScreen={this.state.fullScreenModal}
                open={this.state.finishedModal}
                onClose={this.finishedModalClose.bind(this)}
                aria-labelledby="i_modalConfirm"
              >
                <DialogTitle
                  id="i_modalConfirm"
                  style={{width: '100%', minWidth: this.state.finishedModalMinWidth}}
                >
                  {"Confirmação"}
                </DialogTitle>
                <DialogContent>
                {
                  this.state.finishedLoading === false ? (
                  <DialogContentText>
                    Deseja realmente salvar a proposta?
                  </DialogContentText>
                  ) : (
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={2} lg={2}>{''}</Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8} style={{textAlign: 'center', marginTop: 30}}>
                      <LinearProgress variant="determinate" value={this.state.finishedLoadingCompleted} />
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                        {this.state.finishedLoadingMsg}
                      </Typography>

                      {
                        this.state.proposalSuccess === true ? (
                          this.state.objectPlan.publico === 'Servidor' ? (
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 40}}>
                        <br/><br/>
                        Foi enviado um email para o Servidor Público, com as instruções para a conclusão do cadastro desta proposta.<br/><br/>
                        Esta proposta permanecerá com o status de "Aguardando confirmação do cliente" até que seja realizado a devida confirmação e aceite dos termos do contrato na "aréa do cliente".<br/>
                      </Typography>
                          ) : (
                            this.state.objectPlan.publico === 'Funcionário de Empresa' ? (
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 40}}>
                        Foi enviado um email para o Funcionário com o resumo desta proposta.<br/><br/>
                        Esta proposta permanecerá em aberto até que seja realizada a confirmação pelo email do funcionário.<br/><br/>
                      </Typography>
                            ) : (
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 40}}>
                        Foi enviado um email para o Responsável Financeiro com as instruções de pagamento.<br/><br/>
                        Esta proposta permanecerá "pendente de pagamento" até que seja realizado o pagamento na "área do cliente".<br/><br/>
                      </Typography>
                            )
                          )
                        ) :('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>{''}</Grid>
                  </Grid>
                  )
                }

                </DialogContent>

                {
                  this.state.proposalSuccess === false ? (
                <DialogActions>
                  <Button autoFocus color="primary"
                    onClick={this.finishedModalClose.bind(this)}
                  >
                    NÃO
                  </Button>

                  <Button
                    color="primary"
                    onClick={this.beforeSubmitForm.bind(this)}
                    disabled={this.state.finishedLoading}
                  >
                    SIM
                  </Button>
                </DialogActions>
                  ) : (
                <DialogActions>

                  <ReactToPrint                  
                    trigger={() => 
                      <div style={{marginRight: 10}}>
                      
                        <Button 
                          color="primary"
                        
                        >
                          IMPRIMIR
                        </Button>
                      
                      </div>
                    
                    }
                  
                    content={() => this.printContentFinal}
                    
                  
                  />

                  <Button autoFocus color="primary"
                    onClick={this.goDashboard.bind(this)}
                  >
                    FECHAR
                  </Button>
                </DialogActions>
                  )
                }

              </Dialog>
            </div>
                    ) : ('')
                  )
                )
              )
            }
          </div>
        </div>

        ) : (
          this.state.showPage !== null ? (
        <div>
          <Paper elevation={0} className="paper">
            <div id="formularioTitulo">
              <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                INCLUIR PROPOSTA
              </Typography>
            </div>
          </Paper>

          <div className="paper" style={{marginTop: 80}}>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={2} md={3} lg={4}></Grid>
              <Grid item xs={12} sm={8} md={6} lg={4} style={{textAlign: 'center'}}>
                <MuiAlert severity="error" variant="filled" elevation={0}
                  style={{margin: '0 auto'}}
                >
                  Problema encontrado ao buscar dados do plano
                </MuiAlert>

                <Button
                  style={{
                    fontSize: 11,
                    backgroundColor: configBase.corPrincipal,
                    color: configBase.corSecundaria, width: 140,
                    marginTop: 15
                  }}
                  variant="contained"
                  size="small"
                  onClick={this.reloadPage}
                  color="primary"
                >
                  RECARREGAR
                </Button>
              </Grid>
              <Grid item xs={12} sm={2} md={3} lg={4}></Grid>
            </Grid>
          </div>
        </div>
            ) : (
        <div>
          <Paper elevation={0} className="paper">
            <div id="formularioTitulo">
              <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                INCLUIR PROPOSTA
              </Typography>
            </div>
          </Paper>

          <div className="paper" style={{marginTop: 80}}>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={2} md={3} lg={4}></Grid>
              <Grid item xs={12} sm={8} md={6} lg={4} style={{textAlign: 'center'}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO DADOS DO PLANO...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2} md={3} lg={4}></Grid>
            </Grid>
          </div>
        </div>
            )
          )
        }

        <style>{`
          .formularioStepLabel .MuiStepIcon-root.MuiStepIcon-active {
            color: `+configBase.corPrincipal+`;
          }
          .formularioStepLabel .MuiStepIcon-root.MuiStepIcon-active .MuiStepIcon-text {
            fill: `+configBase.corSecundaria+`;
          }
          .formularioStepLabel .MuiStepLabel-label.MuiStepLabel-active {
            color: `+configBase.corPrincipal+`;
          }
        `}</style>

        <Snackbar open={this.state.warningRequest} autoHideDuration={5000} onClose={this.warningClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.warningClose.bind(this)} severity="warning" variant="filled" elevation={6}>
            {this.state.msgWarningRequest}
          </MuiAlert>
        </Snackbar>

        <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
            {this.state.msgErrorRequest}
          </MuiAlert>
        </Snackbar>
      </MainLayout>
    );

  }

}

Formulario.propTypes = {
  showFormFn: PropTypes.func,
  history: PropTypes.object
};

export default withRouter(Formulario);